// import React, { useRef, useState, useEffect, useCallback } from "react";
// import { createPortal } from "react-dom";
// import { Link } from "react-router-dom";
// import { _Api } from "../api/_call";
// import ConfirmationModel from "../common/modules/confirmationmodel";
// import HeldCheckbox from "../common/modules/HeldCheckbox";
// import "rc-slider/assets/index.css";
// import ProductModal from "../common/modules/ProductModal";
// import ProductImageSliderModal from "../common/modules/productImageslider";
// import { Pagination } from "../common/Pagination";
// import Filtermodal from "../common/modules/Filtermodal";
// import SocialModal from "../common/modules/SocialModal/SocialModal";
// import { error, loading, Updateloading } from "../common/helpers/toastify";
// import { useTranslation } from "react-i18next";
// import Select from "react-select";
// import { useSelector } from "react-redux";
// import TableLoader from "../../admin/common/TableLoader";
// import BarcodeModal from "../common/modules/BarcodeModal";
// import product_design from "../../assets/images/product_design.svg";
// import chain_origin from "../../assets/images/chain_origin.svg";
// import diamond_mine from "../../assets/images/diamond_mine.svg";
// import metal_origin from "../../assets/images/metal_origin.svg";
// import handcrafting from "../../assets/images/handcrafting.svg";
// import qc_shipping from "../../assets/images/qc_shipping.svg";
// import chainrelated from "../../assets/images/chainrelated.png";
// import diamondrelated from "../../assets/images/diamondrelated.png";
// import TraceabilityModal from "./TraceabilityModal";
// import traceimg from "../../assets/images/TraceItem_diamond.svg";
// import allocatableimg from "../../assets/images/allocatable-1.svg";
// import grid4img from "../../assets/images/grid-4.png";
// import grid5img from "../../assets/images/grid-5.png";
// import tablerowimg from "../../assets/images/table-row.png";
// import quickviewinvsvg from "../../assets/images/quickviewinv.svg";
// import "./inventory.scss";
// import { buildInventoryProductUpdatePayload } from "../../Helper/inventoryProductPayload";
// import RFIDIcon from "Icons/RFIDIcon";

// const getStackedPriceLineCount = (totalPrice, maxLines) => {
//   if (!totalPrice) return 0;
//   const parts = String(totalPrice)
//     .split("+")
//     .map((part) => part.trim())
//     .filter(Boolean);
//   const count = parts.length;
//   if (!maxLines) return count;
//   return Math.min(count, maxLines);
// };

// const getStatusValueFontClass = (lineCount) => {
//   if (lineCount >= 3) return "inventory-value--3-lines";
//   if (lineCount === 2) return "inventory-value--2-lines";
//   return "";
// };

// const renderStackedTotalPrice = (totalPrice, maxLines) => {
//   if (!totalPrice) return "";
//   const parts = String(totalPrice)
//     .split("+")
//     .map((part) => part.trim())
//     .filter(Boolean);
//   if (parts.length <= 1) return totalPrice;
//   const visibleParts = maxLines ? parts.slice(0, maxLines) : parts;
//   return (
//     <span className="my-inventory-total-price">
//       {visibleParts.map((part, index) => (
//         <span
//           key={`${part}-${index}`}
//           className="my-inventory-total-price__line"
//         >
//           {part}
//         </span>
//       ))}
//     </span>
//   );
// };

// const applyInventoryRowLock = (list, locationId, warehouseId) => {
//   const hasLocationLock = Boolean(locationId);
//   const lockWarehouse =
//     warehouseId && warehouseId !== "null" ? warehouseId : "";
//   return (list || []).map((row) => {
//     if (!hasLocationLock) {
//       return { ...row, rowclass: "" };
//     }
//     if (row?.location_id !== locationId) {
//       return { ...row, rowclass: "row-inactive" };
//     }
//     const rowWarehouse = row?.warehouse_id ? row.warehouse_id : "";
//     if (lockWarehouse && rowWarehouse && rowWarehouse !== lockWarehouse) {
//       return { ...row, rowclass: "row-inactive" };
//     }
//     return { ...row, rowclass: "" };
//   });
// };

// const MyInventory = (props) => {
//   const { t } = useTranslation();
//   const dataFetched = useRef();
//   const colDropdownRefItem = useRef(null);
//   const colDropdownRefCollection = useRef(null);
//   const colDropdownRefMetal = useRef(null);
//   const colDropdownRefStone = useRef(null);
//   const colDropdownRefSize = useRef(null);
//   const colDropdownRefLocation = useRef(null);
//   const colDropdownRefStatus = useRef(null);
//   const colFilterTriggerRefs = useRef({});
//   const stickyThRefs = useRef([]);
//   const stickyTopRef = useRef(null);
//   const tableHeadScrollRef = useRef(null);
//   const tableBodyScrollRef = useRef(null);
//   const tableHeadTableRef = useRef(null);
//   const tableBodyTableRef = useRef(null);
//   const tableScrollSyncLock = useRef(false);
//   const viewDropdownRef = useRef(null);
//   const viewDropdownMenuRef = useRef(null);
//   const [viewDropdownPortalStyle, setViewDropdownPortalStyle] = useState({});
//   const [openColFilter, setOpenColFilter] = useState(null);
//   const [colFilterPortalStyle, setColFilterPortalStyle] = useState({});
//   const [stickyLefts, setStickyLefts] = useState([
//     0, 40, 80, 135, 250, 340, 445,
//   ]);
//   const [inventorylist, setInventorylist] = useState([]);
//   const [inventorycounts, setInventorycounts] = useState();
//   const [filterdata, setFilterdata] = useState();
//   const [showoption, setShowoption] = useState(false);
//   const [showpos, setShowpos] = useState([]);
//   const [transferlist, setTransferlist] = useState([]);
//   const [locationidlist, setLocationidlist] = useState([]);
//   const [showtransfer, setShowtransfer] = useState(false);
//   const [onlyTransfer, setOnlyTransfer] = useState(false);
//   const [filtername, setFiltername] = useState("");
//   const [limit, setLimit] = useState(100);
//   const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
//   const [SelectAllStatus, setSelectAllStatus] = useState();
//   const [Selectlist, setSelectlist] = useState([]);
//   const [getoneproduct, setOneproduct] = useState();
//   const [imageid, setImageid] = useState();
//   const [socialurl, setSocialurl] = useState();
//   const [shareloader, setShareloader] = useState(false);
//   const [selectedlocation, setSelectedlocation] = useState();
//   const [selectedwarehouse, setSelectedwarehouse] = useState("");
//   const rowLockRef = useRef({ locationId: "", warehouseId: "", active: false });
//   const [product_id, setProduct_id] = useState();
//   const [cart_id, setCart_id] = useState();
//   const [getSkipNumbers, setSkipNumbers] = useState(0);
//   const [datalodaer, setDatsLodaer] = useState(false);
//   const [datatotal, setDatatotal] = useState({ total_qty: 0, total_price: "" });
//   const [traceData, setTraceData] = useState();
//   const [traceDetail, setTraceDetail] = useState({});
//   const [payload, setPayload] = useState();
//   const [invCount, setInvCount] = useState(0);
//   const [viewMode, setViewMode] = useState("table");
//   const [viewDropdownOpen, setViewDropdownOpen] = useState(false);
//   const [colFilterOptions, setColFilterOptions] = useState({});
//   const [syncRfidLoading, setSyncRfidLoading] = useState(false);
//   const [rfidIntegrate, setRfidIntegrate] = useState();
//   const generalsettings = useSelector((state) => state.app.generalsettings);

//   const handleViewModeChange = (mode) => {
//     setViewMode(mode);
//     setSelectlist([]);
//     setTransferlist([]);
//     setLocationidlist([]);
//     setSelectAllStatus(false);
//     setShowoption(false);
//     setOnlyTransfer(false);
//     setShowtransfer(false);
//     setShowpos([]);
//     setSelectedlocation("");
//     setSelectedwarehouse("");
//     rowLockRef.current = { locationId: "", warehouseId: "", active: false };
//     setInventorylist((prev) => applyInventoryRowLock(prev, "", ""));
//   };

//   const getStatusDotClass = (status) => {
//     const map = {
//       stock: "light-blue-bg",
//       transit: "green-bg",
//       warehouse: "status-gray-bg",
//       reserve: "yellow-bg",
//       repair_order: "purple-bg",
//       custom_order: "danger-bg",
//     };
//     return map[status] || "light-blue-bg";
//   };

//   const getStatusLabel = (status) => {
//     const map = {
//       stock: "Stock",
//       transit: "Transit",
//       warehouse: "Warehouse",
//       reserve: "Reserve",
//       repair_order: "Repair Order",
//       custom_order: "Custom Order",
//     };
//     return map[status] || status || "";
//   };
//   const [activeFilters, setActiveFilters] = useState({
//     item: [],
//     collection: [],
//     metal: [],
//     stone: [],
//     size: [],
//     location: [],
//     status: [],
//     price: [],
//   });
//   const [colFilterSearch, setColFilterSearch] = useState({
//     item: "",
//     collection: "",
//     metal: "",
//     stone: "",
//     size: "",
//     location: "",
//     status: "",
//   });
//   const iconMap = {
//     "652e2c3f7ab8c5b2750a4f03": { icon: chain_origin, color: "#3484D4" },
//     "652e2c3f7ab8c5b2750a4f04": { icon: chainrelated, color: "#3484D4" },
//     "652e2c3f7ab8c5b2750a4f05": { icon: chainrelated, color: "#3484D4" },
//     "652e2c3f7ab8c5b2750a4f08": { icon: diamond_mine, color: "#212121" },
//     "652e2c3f7ab8c5b2750a4f09": { icon: diamondrelated, color: "#212121" },
//     "652e2c3f7ab8c5b2750a4f06": { icon: diamondrelated, color: "#212121" },
//     "652e2c3f7ab8c5b2750a4f07": { icon: diamondrelated, color: "#212121" },
//     "652e2c3f7ab8c5b2750a4f0a": { icon: metal_origin, color: "#73AAE1" },
//     "652e2c3f7ab8c5b2750a4f0b": { icon: handcrafting, color: "#87898C" },
//     "652e2c3f7ab8c5b2750a4f0c": { icon: handcrafting, color: "#87898C" },
//     "652e2c3f7ab8c5b2750a4f0d": { icon: handcrafting, color: "#87898C" },
//     "652e2c3f7ab8c5b2750a4f02": { icon: qc_shipping, color: "#73AB8B" },
//   };

//   const getTimelineData = (data) => {
//     const timeline = [];

//     // 1. Add product design at top
//     timeline.push({
//       id: "product_design",
//       name: "Product Design",
//       countries: [data?.product_design_trace ? data?.product_design_trace : []],
//       transactionId: data?.product_design_trace_detail?.transactionId || "-",
//       iconName: { icon: product_design, color: "#3C609C" },
//     });

//     // 2. Add traceability items sorted by iconMap order (reverse order)
//     const iconMapOrder = [
//       "652e2c3f7ab8c5b2750a4f03",
//       "652e2c3f7ab8c5b2750a4f04",
//       "652e2c3f7ab8c5b2750a4f05",
//       "652e2c3f7ab8c5b2750a4f08",
//       "652e2c3f7ab8c5b2750a4f09",
//       "652e2c3f7ab8c5b2750a4f06",
//       "652e2c3f7ab8c5b2750a4f07",
//       "652e2c3f7ab8c5b2750a4f0a",
//       "652e2c3f7ab8c5b2750a4f0b",
//       "652e2c3f7ab8c5b2750a4f0c",
//       "652e2c3f7ab8c5b2750a4f0d",
//       "652e2c3f7ab8c5b2750a4f02",
//     ];

//     // Items in the defined order
//     const orderedItems = iconMapOrder
//       .filter((key) => data.traceability[key])
//       .map((key) => ({
//         id: key,
//         ...data.traceability[key],
//         iconName: iconMap[key]
//           ? iconMap[key]
//           : {
//               icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
//               color: "#606060",
//             },
//       }));

//     // Items not in iconMapOrder (put at last)
//     const unorderedItems = Object.keys(data.traceability)
//       .filter((key) => !iconMapOrder.includes(key))
//       .map((key) => ({
//         id: key,
//         ...data.traceability[key],
//         iconName: iconMap[key]
//           ? iconMap[key]
//           : {
//               icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
//               color: "#606060",
//             },
//       }));

//     timeline.push(...orderedItems, ...unorderedItems);
//     return timeline;
//   };

//   const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
//   const getshareinventary = async () => {
//     setShareloader(true);
//     try {
//       const postdata = {
//         item: payload?.item ? payload?.item : [],
//         collection: payload?.collection ? payload?.collection : [],
//         metal: payload?.metal ? payload?.metal : [],
//         size: payload?.size ? payload?.size : [],
//         stone: payload?.stone ? payload?.stone : [],
//         productStatus: payload?.status ? payload?.status : [],
//         location: payload?.location ? payload?.location : [],
//         price: payload?.price ? payload?.price : [],
//         search: filtername,
//       };
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/inventory/print/myInventory`,
//       );

//       if (res.code === 200) {
//         setSocialurl(res?.link);
//         setShareloader(false);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const selectOptions = [
//     { label: 100, value: 100 },
//     { label: 200, value: 200 },
//     { label: 300, value: 300 },
//   ];

//   const getprintmyinventary = async () => {
//     let GetloadingID = loading();
//     try {
//       const postdata = {
//         item: payload?.item ? payload?.item : [],
//         collection: payload?.collection ? payload?.collection : [],
//         metal: payload?.metal ? payload?.metal : [],
//         size: payload?.size ? payload?.size : [],
//         stone: payload?.stone ? payload?.stone : [],
//         productStatus: payload?.productStatus ? payload?.productStatus : [],
//         location: payload?.location ? payload?.location : [],
//         price: payload?.price ? payload?.price : [],
//         search: filtername,
//       };
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/inventory/print/myInventory`,
//       );
//       if (res.code === 200) {
//         setTimeout(() => {
//           const exportLinkElement = document.createElement("a");
//           exportLinkElement.hidden = true;
//           exportLinkElement.download = res?.name ? res?.name : "report.pdf";
//           exportLinkElement.href = res?.link;
//           exportLinkElement.text = "downloading...";
//           exportLinkElement.setAttribute("target", "_blank");
//           document.body.appendChild(exportLinkElement);
//           exportLinkElement.click();
//           exportLinkElement.remove();
//           Updateloading(t, GetloadingID, t("download successfully"));
//         }, 50);
//       } else {
//         Updateloading(
//           t,
//           GetloadingID,
//           res?.message ? res?.message : res?.errors,
//           "error",
//         );
//       }
//     } catch (err) {
//       console.log(err, "err");
//       Updateloading(t, GetloadingID, err, t("error"));
//     }
//   };

//   const handleChange = (event) => {
//     if (event.target.checked) {
//       let posorderarray = [];
//       const selected = [...Selectlist];
//       const mainarray = [...inventorylist];
//       const transferarray = [...transferlist];
//       const locationarray = [...locationidlist];
//       let checking = document.querySelectorAll(".inventorytablecheck");
//       let hasOnlyTransfer = false;
//       for (let i = 0; i < checking.length; i++) {
//         if (checking[i].checked) {
//           posorderarray.push(i);
//           setShowoption(true);
//           if (
//             checking[i].getAttribute("data-status") === "reserve" &&
//             checking[i].getAttribute("data-isnottransferable") === "false"
//           ) {
//             hasOnlyTransfer = true;
//           }
//         }
//         setShowpos(posorderarray);
//       }
//       setOnlyTransfer(hasOnlyTransfer);
//       if (selected.filter((e) => e === event.target.id).length === 0) {
//         selected.push(event.target.id);
//       }
//       setSelectlist(selected);
//       const currentid = mainarray.filter((all) => {
//         return all.id === event.target.id;
//       });
//       const isFirstSelection = Selectlist.length === 0;
//       const lockLocation = isFirstSelection
//         ? currentid[0]?.location_id
//         : selectedlocation || currentid[0]?.location_id;
//       const lockWarehouse = isFirstSelection
//         ? currentid[0]?.warehouse_id
//           ? currentid[0].warehouse_id
//           : "null"
//         : selectedwarehouse ||
//           (currentid[0]?.warehouse_id ? currentid[0].warehouse_id : "null");
//       setSelectedlocation(lockLocation);
//       setSelectedwarehouse(lockWarehouse);
//       rowLockRef.current = {
//         locationId: lockLocation,
//         warehouseId: lockWarehouse,
//         active: true,
//       };
//       setInventorylist((prev) =>
//         applyInventoryRowLock(prev, lockLocation, lockWarehouse),
//       );
//       if (transferarray?.length === 0) {
//         setShowtransfer(true);
//         locationarray.push(currentid[0]?.location_id);
//         setLocationidlist(locationarray);
//         transferarray.push(event.target.id);
//         setTransferlist(transferarray);
//       } else {
//         const checkloc = locationarray.filter(
//           (locid) => locid === currentid[0]?.location_id,
//         );
//         if (checkloc?.length) {
//           transferarray.push(event.target.id);
//           setShowtransfer(true);
//           setTransferlist(transferarray);
//         } else {
//           setShowtransfer(false);
//         }
//       }
//     } else {
//       let array = [];
//       let posorderarray = [];
//       const mainarray = [...inventorylist];
//       const transferarray = [...transferlist];
//       const locationarray = [...locationidlist];
//       let checking = document.querySelectorAll(".inventorytablecheck");
//       let hasOnlyTransfer = false;
//       for (let i = 0; i < checking.length; i++) {
//         if (checking[i].checked) {
//           array.push(i);
//           posorderarray.push(i);
//           setShowoption(true);
//           if (
//             checking[i].getAttribute("data-status") === "reserve" &&
//             checking[i].getAttribute("data-isnottransferable") === "false"
//           ) {
//             hasOnlyTransfer = true;
//           }
//         }
//         setShowpos(posorderarray);
//       }
//       setOnlyTransfer(hasOnlyTransfer);
//       setSelectlist((current) =>
//         current.filter((item) => item !== event.target.id),
//       );
//       if (array.length === 0) {
//         setShowoption(false);
//         setOnlyTransfer(false);
//         setSelectedlocation("");
//         setSelectedwarehouse("");
//         rowLockRef.current = { locationId: "", warehouseId: "", active: false };
//         setInventorylist((prev) => applyInventoryRowLock(prev, "", ""));
//       }

//       const currentid = mainarray.filter((all) => {
//         return all.id === event.target.id;
//       });
//       if (transferarray?.length === 1) {
//         setLocationidlist((current) =>
//           current.filter((item) => item !== currentid[0]?.location_id),
//         );
//         setTransferlist((current) =>
//           current.filter((item) => item !== event.target.id),
//         );
//         setShowtransfer(true);
//         setSelectedlocation("");
//         setSelectedwarehouse("");
//       } else {
//         const checkloc = locationarray.filter(
//           (locid) => locid === currentid[0]?.location_id,
//         );
//         if (checkloc?.length) {
//           setTransferlist((current) =>
//             current.filter((item) => item !== event.target.id),
//           );
//           var callcheck = document.querySelectorAll(".inventorytablecheck");
//           for (var i = 0; i < callcheck.length; i++) {
//             if (callcheck[i].checked) {
//               let locationid = callcheck[i].getAttribute("data-locationid");
//               const notmatch = locationarray.filter(
//                 (locid) => locid !== locationid,
//               );
//               if (notmatch.length) {
//                 setShowtransfer(false);
//               } else {
//                 setShowtransfer(true);
//               }
//             }
//           }
//         } else {
//           if (transferarray?.length) {
//             setShowtransfer(true);
//           } else {
//             setShowtransfer(false);
//           }
//         }
//       }
//     }
//   };

//   const inventorycountsapi = async () => {
//     try {
//       const postdata = {
//         location: [],
//       };
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/my/inventory-statics-optimized`,
//       );
//       if (res?.code === 200) {
//         setInventorycounts(res?.data);
//         setRfidIntegrate(res?.data?.rfidIntegration?.status || false);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   // const inventorylowercount = async (filter, search, limit) => {
//   //   try {
//   //     const postdata = {
//   //       item: filter?.item ? filter?.item : [],
//   //       collection: filter?.collection ? filter?.collection : [],
//   //       metal: filter?.metal ? filter?.metal : [],
//   //       size: filter?.size ? filter?.size : [],
//   //       stone: filter?.stone ? filter?.stone : [],
//   //       productStatus: filter?.status ? filter?.status : [],
//   //       location: filter?.location ? filter?.location : [],
//   //       price: filter?.price ? filter?.price : [],
//   //       search: search === "" ? search : filtername,
//   //       limit: limit,
//   //       allocated: filter?.allocated ? filter?.allocated : false,
//   //       traced: filter?.traced ? filter?.traced : false,
//   //     };
//   //     let res = await _Api(
//   //       postdata,
//   //       `api/v1/Inventory/my/inventory-lowerStatics`
//   //     );
//   //     if (res?.code === 200) {
//   //       setDatatotal(res?.data);
//   //     }
//   //   } catch (err) {
//   //     console.log(err, "err");
//   //   }
//   // };
//   const filterbyname = (search) => {
//     setstate({ ...state, currentPage: 1 });
//     Getmyinventory(1, limit, filterdata, search, 0);
//   };
//   const getlimit = (limit) => {
//     setLimit(limit);
//     Getmyinventory(1, limit, filterdata);
//     setstate({ ...state, currentPage: 1 });
//   };
//   const [state, setstate] = useState({
//     totalPages: 20,
//     currentPage: 1,
//   });
//   const { totalPages, currentPage } = state;
//   const handlePaginations = (current) => {
//     setstate({ ...state, currentPage: current });
//     Getmyinventory(current, "", filterdata);
//   };

//   const Getmyinventory = useCallback(
//     async (current, firstlimit, filter, search, skip) => {
//       let tablelimit = 1;
//       if (firstlimit === "ALL") {
//         tablelimit = 1;
//       } else {
//         tablelimit = firstlimit ? firstlimit : limit;
//       }
//       setDatsLodaer(true);
//       var skipNumber = current ? (current - 1) * tablelimit : 0;
//       setInvCount(0);
//       try {
//         const postdata = {
//           item: filter?.item ? filter?.item : [],
//           collection: filter?.collection ? filter?.collection : [],
//           metal: filter?.metal ? filter?.metal : [],
//           size: filter?.size ? filter?.size : [],
//           stone: filter?.stone ? filter?.stone : [],
//           productStatus: filter?.status ? filter?.status : [],
//           location: filter?.location ? filter?.location : [],
//           price: filter?.price ? filter?.price : [],
//           search: search === "" ? search : filtername,
//           limit: firstlimit ? firstlimit : limit,
//           skip: skip === 0 ? skip : skipNumber,
//           allocated: filter?.allocated ? filter?.allocated : false,
//           traced: filter?.traced ? filter?.traced : false,
//         };
//         setPayload(postdata);
//         let resPoinventory = await _Api(
//           postdata,
//           `api/v1/Inventory/my/listoptimized`,
//         );
//         if (resPoinventory?.code === 200) {
//           setFilterdata(filter);
//           setSelectAllStatus(false);
//           setDatsLodaer(false);
//           setSkipNumbers(skip === 0 ? skip : skipNumber);
//           let pageini = 1;
//           if (postdata.limit === "ALL") {
//             pageini = resPoinventory?.total;
//           } else {
//             pageini = postdata.limit;
//           }
//           setstate({
//             ...state,
//             totalPages: Math.ceil(resPoinventory?.total / pageini),
//             currentPage: current ? current : 1,
//           });

//           setInventorylist(
//             applyInventoryRowLock(
//               (resPoinventory?.data || []).map((row) => ({
//                 ...row,
//                 rowclass: "",
//               })),
//               rowLockRef.current.active ? rowLockRef.current.locationId : "",
//               rowLockRef.current.active ? rowLockRef.current.warehouseId : "",
//             ),
//           );
//           setInvCount(resPoinventory?.total);
//           setDatatotal({
//             total_qty: resPoinventory?.total_qty ?? 0,
//             total_price: resPoinventory?.total_price ?? "",
//           });
//           // inventorylowercount(
//           //   filter,
//           //   search,
//           //   parseInt(postdata?.limit) + parseInt(postdata?.skip)
//           // );
//         }
//       } catch (err) {
//         console.log(err, "err");
//       }
//       // eslint-disable-next-line
//     },
//     [filtername, limit, state],
//   );

//   const editproduct_submit = useCallback(async () => {
//     if (!getoneproduct?._id) {
//       error(t("The _id field is required."));
//       return;
//     }

//     const loadingId = loading();
//     try {
//       const postdata = buildInventoryProductUpdatePayload(getoneproduct);
//       const res = await _Api(
//         postdata,
//         "api/v1/Inventory/my/update-inventory-product",
//       );

//       if (res?.code === 200) {
//         Updateloading(
//           t,
//           loadingId,
//           res?.message || t("Inventory product updated"),
//         );
//         setInventorylist((prev) =>
//           prev.map((item) =>
//             item._id === getoneproduct._id
//               ? {
//                   ...item,
//                   ...getoneproduct,
//                   additional_note: postdata.additional_note,
//                   extra_po_information: postdata.additional_note,
//                 }
//               : item,
//           ),
//         );
//         Getmyinventory(currentPage, limit, filterdata, filtername);
//         return;
//       }

//       if (res?.code === 400 && res?.errors) {
//         Updateloading(t, loadingId, res.errors, "error");
//         return;
//       }

//       Updateloading(
//         t,
//         loadingId,
//         res?.message || t("Failed to update inventory product"),
//         "error",
//       );
//     } catch (err) {
//       console.log(err, "err");
//       Updateloading(
//         t,
//         loadingId,
//         err?.message || t("Something went wrong"),
//         "error",
//       );
//     }
//   }, [
//     getoneproduct,
//     Getmyinventory,
//     currentPage,
//     limit,
//     filterdata,
//     filtername,
//     t,
//   ]);

//   useEffect(() => {
//     if (dataFetched.current) return;
//     dataFetched.current = true;
//     inventorycountsapi();
//     Getmyinventory();
//     // eslint-disable-next-line
//   }, [Getmyinventory]);

//   // Sync all inventory data to RFID (same filters as my/list, without pagination)
//   const handleSyncRfid = async () => {
//     const activeFilter = filterdata || {};
//     const postdata = {
//       item: activeFilter?.item ? activeFilter?.item : [],
//       collection: activeFilter?.collection ? activeFilter?.collection : [],
//       metal: activeFilter?.metal ? activeFilter?.metal : [],
//       size: activeFilter?.size ? activeFilter?.size : [],
//       stone: activeFilter?.stone ? activeFilter?.stone : [],
//       productStatus: activeFilter?.status ? activeFilter?.status : [],
//       location: activeFilter?.location ? activeFilter?.location : [],
//       price: activeFilter?.price ? activeFilter?.price : [],
//       search: filtername || "",
//       allocated: activeFilter?.allocated ? activeFilter?.allocated : false,
//       traced: activeFilter?.traced ? activeFilter?.traced : false,
//     };

//     setSyncRfidLoading(true);
//     let GetloadingID = loading();
//     try {
//       let res = await _Api(postdata, `api/v1/Inventory/my/sync-rfid`);
//       if (res?.statusCode === 200) {
//         Updateloading(
//           t,
//           GetloadingID,
//           res?.message || t("RFID synced successfully"),
//         );
//       } else {
//         Updateloading(
//           t,
//           GetloadingID,
//           res?.message || res?.errors || t("RFID sync failed"),
//           "error",
//         );
//       }
//     } catch (err) {
//       console.log(err, "err");
//       Updateloading(t, GetloadingID, err?.message || t("error"), "error");
//     } finally {
//       setSyncRfidLoading(false);
//     }
//   };

//   const handleTraceData = (key) => {
//     const mainarray = [...inventorylist];
//     const item = mainarray[key];

//     const tracesDetail = {
//       image: item?.main_image || "",
//       name: item?.name || "",
//       SKU: item?.SKU || "",
//       pos_Qty: item?.po_QTY || 1,
//       stock_id: item?.stock_id || "-",
//       transactionId: item?.product_design_trace_detail?.transactionId,
//     };
//     setTraceDetail(tracesDetail);

//     // safely extract traceability data
//     const traceability = item?.traceability || {};
//     const product_design_trace = item?.product_design_trace || {
//       label: "Unknown",
//       value: "",
//     };
//     const product_design_trace_detail = item?.product_design_trace_detail || {
//       transactionId: "-",
//     };

//     const tracesData = {
//       traceability,
//       product_design_trace,
//       product_design_trace_detail,
//     };

//     const arrtrace = getTimelineData(tracesData);
//     setTraceData(arrtrace);
//   };

//   useEffect(() => {
//     if (SelectAllStatus) {
//       let callcheck = document.querySelectorAll(".inventorytablecheck");
//       const selected = [...Selectlist];
//       const transferarray = [...transferlist];
//       let location_id = [];
//       let warehouse_id = [];
//       for (let i = 0; i < callcheck.length; i++) {
//         let status = callcheck[i].getAttribute("data-status");
//         let isHeld = callcheck[i].getAttribute("data-isadjustmentheld");
//         let isNotTransferable = callcheck[i].getAttribute(
//           "data-isnottransferable",
//         );
//         if (
//           status === "reserve" ||
//           status === "transit" ||
//           isHeld === "true" ||
//           isNotTransferable === "true"
//         ) {
//           callcheck[i].checked = false;
//         }
//         if (callcheck[i].checked) {
//           let id = callcheck[i].getAttribute("data-id");
//           let location = callcheck[i].getAttribute("data-locationid");
//           let warehouse = callcheck[i].getAttribute("warehouse_id");
//           if (!location_id.length) {
//             location_id.push(location);
//             warehouse_id.push(warehouse);
//           }
//           if (location !== location_id[0]) {
//             callcheck[i].checked = false;
//             continue;
//           }
//           if (selected.indexOf(id) === -1) {
//             selected.push(id);
//           }
//           setShowtransfer(true);
//           transferarray.push(id);
//         }
//       }
//       setSelectedlocation(location_id[0]);
//       if (warehouse_id[0]) {
//         setSelectedwarehouse(warehouse_id[0]);
//       } else {
//         setSelectedwarehouse("null");
//       }
//       setTransferlist(transferarray);
//       setSelectlist(selected);
//       rowLockRef.current = {
//         locationId: location_id[0],
//         warehouseId: warehouse_id[0] || "null",
//         active: Boolean(location_id[0]),
//       };
//       setInventorylist((prev) =>
//         applyInventoryRowLock(prev, location_id[0], warehouse_id[0] || "null"),
//       );
//     } else if (SelectAllStatus === false) {
//       let callcheck = document.querySelectorAll(".inventorytablecheck");
//       let newSelectlist = [...Selectlist];
//       let newTransferlist = [...transferlist];
//       for (let i = 0; i < callcheck.length; i++) {
//         let id = callcheck[i].getAttribute("data-id");
//         newSelectlist = newSelectlist.filter((item) => item !== id);
//         newTransferlist = newTransferlist.filter((item) => item !== id);
//       }
//       setSelectlist(newSelectlist);
//       setTransferlist(newTransferlist);
//       if (newSelectlist.length === 0) {
//         setSelectedlocation("");
//         setSelectedwarehouse("");
//         rowLockRef.current = { locationId: "", warehouseId: "", active: false };
//         setInventorylist((prev) => applyInventoryRowLock(prev, "", ""));
//       }
//     }
//     // Only react to the header checkbox. Re-running on inventorylist updates
//     // cleared the location lock right after a row was selected.
//     // eslint-disable-next-line
//   }, [SelectAllStatus]);

//   useEffect(() => {
//     getColFilterOptions();
//   }, []);

//   useEffect(() => {
//     const el = stickyTopRef.current;
//     if (!el) return undefined;
//     const page = el.closest(".my-inventory-page");
//     const apply = () => {
//       if (!page) return;
//       page.style.setProperty(
//         "--inventory-sticky-block-height",
//         `${el.offsetHeight}px`,
//       );
//     };
//     apply();
//     const observer = new ResizeObserver(apply);
//     observer.observe(el);
//     window.addEventListener("resize", apply);
//     return () => {
//       observer.disconnect();
//       window.removeEventListener("resize", apply);
//     };
//   }, []);

//   const syncInventoryTableScroll = (source) => {
//     if (tableScrollSyncLock.current) return;
//     const head = tableHeadScrollRef.current;
//     const body = tableBodyScrollRef.current;
//     if (!head || !body) return;
//     tableScrollSyncLock.current = true;
//     if (source === "head") {
//       body.scrollLeft = head.scrollLeft;
//     } else {
//       head.scrollLeft = body.scrollLeft;
//     }
//     requestAnimationFrame(() => {
//       tableScrollSyncLock.current = false;
//     });
//   };

//   useEffect(() => {
//     if (viewMode !== "table") return undefined;

//     let frame = 0;
//     const syncInventoryTableWidths = () => {
//       cancelAnimationFrame(frame);
//       frame = requestAnimationFrame(() => {
//         const headTable = tableHeadTableRef.current;
//         const bodyTable = tableBodyTableRef.current;
//         if (!headTable || !bodyTable) return;

//         const headThs = headTable.querySelectorAll("thead th");
//         const bodyRow = bodyTable.querySelector("tbody tr");
//         const footRow = bodyTable.querySelector("tfoot tr");
//         const count = headThs.length;
//         if (!count) return;

//         headTable.style.width = "max-content";
//         bodyTable.style.width = "max-content";
//         headTable.style.tableLayout = "auto";
//         bodyTable.style.tableLayout = "auto";
//         headThs.forEach((th) => {
//           th.style.width = "";
//           th.style.minWidth = "";
//           th.style.maxWidth = "";
//         });
//         bodyTable.querySelectorAll("td, th").forEach((cell) => {
//           cell.style.width = "";
//           cell.style.minWidth = "";
//           cell.style.maxWidth = "";
//         });

//         const widths = [];
//         for (let i = 0; i < count; i += 1) {
//           const hw = headThs[i].getBoundingClientRect().width;
//           const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
//           const fw = footRow?.children[i]?.getBoundingClientRect().width || 0;
//           widths.push(Math.ceil(Math.max(hw, bw, fw, 40)));
//         }
//         const total = widths.reduce((sum, w) => sum + w, 0);
//         headTable.style.tableLayout = "fixed";
//         bodyTable.style.tableLayout = "fixed";
//         headTable.style.width = `${total}px`;
//         bodyTable.style.width = `${total}px`;

//         for (let i = 0; i < count; i += 1) {
//           const widthPx = `${widths[i]}px`;
//           headThs[i].style.width = widthPx;
//           headThs[i].style.minWidth = widthPx;
//           headThs[i].style.maxWidth = widthPx;
//           bodyTable
//             .querySelectorAll(`tr > :nth-child(${i + 1})`)
//             .forEach((cell) => {
//               cell.style.width = widthPx;
//               cell.style.minWidth = widthPx;
//               cell.style.maxWidth = widthPx;
//             });
//         }

//         let acc = 0;
//         const lefts = stickyThRefs.current.map((th) => {
//           const left = acc;
//           if (th) acc += th.offsetWidth;
//           return left;
//         });
//         setStickyLefts((prev) => {
//           if (
//             prev.length === lefts.length &&
//             prev.every((value, index) => value === lefts[index])
//           ) {
//             return prev;
//           }
//           return lefts;
//         });
//       });
//     };

//     syncInventoryTableWidths();
//     window.addEventListener("resize", syncInventoryTableWidths);
//     const observer = new ResizeObserver(syncInventoryTableWidths);
//     if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
//     if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

//     return () => {
//       cancelAnimationFrame(frame);
//       window.removeEventListener("resize", syncInventoryTableWidths);
//       observer.disconnect();
//     };
//   }, [viewMode, inventorylist, datalodaer]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         viewDropdownRef.current &&
//         !viewDropdownRef.current.contains(e.target) &&
//         !viewDropdownMenuRef.current?.contains(e.target)
//       ) {
//         setViewDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const updateViewDropdownPosition = useCallback(() => {
//     const trigger = viewDropdownRef.current;
//     if (!trigger) return;
//     const rect = trigger.getBoundingClientRect();
//     setViewDropdownPortalStyle({
//       position: "fixed",
//       top: rect.bottom + 4,
//       right: Math.max(8, window.innerWidth - rect.right),
//       background: "#fff",
//       border: "1px solid #E5E5E5",
//       borderRadius: "6px",
//       boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       padding: "6px",
//       display: "flex",
//       gap: "4px",
//       zIndex: 4000,
//     });
//   }, []);

//   useEffect(() => {
//     if (!viewDropdownOpen) return undefined;
//     updateViewDropdownPosition();
//     window.addEventListener("resize", updateViewDropdownPosition);
//     window.addEventListener("scroll", updateViewDropdownPosition, true);
//     return () => {
//       window.removeEventListener("resize", updateViewDropdownPosition);
//       window.removeEventListener("scroll", updateViewDropdownPosition, true);
//     };
//   }, [viewDropdownOpen, updateViewDropdownPosition]);

//   const getColFilterOptions = async () => {
//     try {
//       let res = await _Api(
//         { custom_filter_enable: true },
//         `api/v1/Inventory/my/filter`,
//       );
//       if (res?.code === 200) {
//         setColFilterOptions(res?.data);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const hendleColDropdownHide = () => {
//     setOpenColFilter(null);
//   };

//   const getColFilterMenuRef = (filterKey) => {
//     const refMap = {
//       item: colDropdownRefItem,
//       collection: colDropdownRefCollection,
//       metal: colDropdownRefMetal,
//       stone: colDropdownRefStone,
//       size: colDropdownRefSize,
//       location: colDropdownRefLocation,
//       status: colDropdownRefStatus,
//     };
//     return refMap[filterKey];
//   };

//   const updateColFilterPortalPosition = (filterKey) => {
//     const trigger = colFilterTriggerRefs.current[filterKey];
//     if (!trigger) return;
//     const rect = trigger.getBoundingClientRect();
//     const viewportWidth =
//       window.innerWidth || document.documentElement.clientWidth;
//     const menuWidth = 286;
//     let left = rect.left;
//     if (left + menuWidth + 8 > viewportWidth) {
//       left = Math.max(8, viewportWidth - menuWidth - 8);
//     }
//     setColFilterPortalStyle({
//       position: "fixed",
//       top: rect.bottom + 6,
//       left,
//       width: menuWidth,
//       zIndex: 3000,
//     });
//   };

//   useEffect(() => {
//     if (!openColFilter) return undefined;
//     updateColFilterPortalPosition(openColFilter);
//     const handleReposition = () => updateColFilterPortalPosition(openColFilter);
//     const handleOutsideClick = (event) => {
//       const trigger = colFilterTriggerRefs.current[openColFilter];
//       const menu = getColFilterMenuRef(openColFilter)?.current;
//       if (trigger?.contains(event.target) || menu?.contains(event.target)) {
//         return;
//       }
//       setOpenColFilter(null);
//     };
//     window.addEventListener("resize", handleReposition);
//     window.addEventListener("scroll", handleReposition, true);
//     document.addEventListener("mousedown", handleOutsideClick);
//     return () => {
//       window.removeEventListener("resize", handleReposition);
//       window.removeEventListener("scroll", handleReposition, true);
//       document.removeEventListener("mousedown", handleOutsideClick);
//     };
//   }, [openColFilter]);

//   const handleColFilterItemChange = (event, value, filterKey) => {
//     setActiveFilters((prev) => ({
//       ...prev,
//       [filterKey]: event.target.checked
//         ? [...prev[filterKey], value]
//         : prev[filterKey].filter((v) => v !== value),
//     }));
//   };

//   const handleColFilterSelectAll = (event, filterKey) => {
//     const isStatus = filterKey === "status";
//     const allValues = (colFilterOptions?.[filterKey] || []).map((o) =>
//       isStatus ? o.value : o._id,
//     );
//     setActiveFilters((prev) => ({
//       ...prev,
//       [filterKey]: event.target.checked ? allValues : [],
//     }));
//   };

//   const applyColFilter = (filterKey) => {
//     Getmyinventory(1, limit, activeFilters, filtername, 0);
//     hendleColDropdownHide();
//   };

//   const handleClearAllFilters = () => {
//     const empty = {
//       item: [],
//       collection: [],
//       metal: [],
//       stone: [],
//       size: [],
//       location: [],
//       status: [],
//       price: [],
//     };
//     setActiveFilters(empty);
//     setColFilterSearch({
//       item: "",
//       collection: "",
//       metal: "",
//       stone: "",
//       size: "",
//       location: "",
//       status: "",
//     });
//     Getmyinventory(1, limit, empty, filtername, 0);
//   };

//   const renderColFilterDropdown = (filterKey, dropdownRef) => {
//     const isStatus = filterKey === "status";
//     const options = colFilterOptions?.[filterKey] || [];
//     const checkedVals = activeFilters[filterKey] || [];
//     const searchTerm = colFilterSearch[filterKey] || "";
//     const filteredOptions = searchTerm
//       ? options.filter((o) =>
//           o?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
//         )
//       : options;
//     const isOpen = openColFilter === filterKey;

//     const menuContent = (
//       <div
//         className="dropdown-menu show com-custom-table-tag-filter-menu dtbs-filter-dropdown-menu dtbs-filter-portal-menu p-0 border-0 overflow-hidden"
//         style={colFilterPortalStyle}
//         ref={dropdownRef}
//         onClick={(e) => e.stopPropagation()}
//       >
//         {!isStatus && (
//           <div className="com-custom-table-tag-filter-menu-search">
//             <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
//               <img
//                 src={base_assets + "images/icons/search-icon.png"}
//                 alt=""
//               />
//               <input
//                 className="border-0"
//                 type="text"
//                 placeholder="Search"
//                 value={searchTerm}
//                 onChange={(e) =>
//                   setColFilterSearch((prev) => ({
//                     ...prev,
//                     [filterKey]: e.target.value,
//                   }))
//                 }
//               />
//             </div>
//           </div>
//         )}
//         <div className="com-custom-table-tag-filter-menu-select">
//           <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
//             <div>
//               <input
//                 className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
//                 type="checkbox"
//                 id={`colfilter-all-${filterKey}`}
//                 onChange={(e) => handleColFilterSelectAll(e, filterKey)}
//                 checked={
//                   options.length > 0 && checkedVals.length === options.length
//                 }
//               />
//               <label
//                 className="form-check-label cursor-pointer fw-semibold"
//                 htmlFor={`colfilter-all-${filterKey}`}
//               >
//                 {t("Select All")}
//               </label>
//             </div>
//             <label>
//               {checkedVals.length}/{options.length} {t("Selected")}
//             </label>
//           </div>
//           <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
//             {filteredOptions.map((opt, idx) => {
//               const val = isStatus ? opt.value : opt._id;
//               const optId = `colfilter-${filterKey}-${idx}`;
//               return (
//                 <li
//                   className="com-custom-table-tag-filter-menu-select-list-single"
//                   key={optId}
//                 >
//                   <input
//                     className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
//                     type="checkbox"
//                     id={optId}
//                     checked={checkedVals.includes(val)}
//                     onChange={(e) =>
//                       handleColFilterItemChange(e, val, filterKey)
//                     }
//                   />
//                   <label
//                     className="form-check-label cursor-pointer"
//                     htmlFor={optId}
//                   >
//                     {opt?.name}
//                   </label>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>
//         <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
//           <button
//             className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
//             onClick={() => {
//               setActiveFilters((prev) => ({ ...prev, [filterKey]: [] }));
//               setColFilterSearch((prev) => ({ ...prev, [filterKey]: "" }));
//             }}
//           >
//             {t("Clear")}
//           </button>
//           <button
//             className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold"
//             onClick={() => applyColFilter(filterKey)}
//           >
//             {t("Apply")}
//           </button>
//         </div>
//       </div>
//     );

//     return (
//       <div
//         className="d-inline-block com-custom-table-tag-filter dtbs-filter-dropdown"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <button
//           ref={(el) => {
//             colFilterTriggerRefs.current[filterKey] = el;
//           }}
//           className="after-none bg-transparent border-0 p-0"
//           type="button"
//           aria-expanded={isOpen}
//           onClick={() => {
//             setOpenColFilter((prev) => {
//               const next = prev === filterKey ? null : filterKey;
//               if (next) {
//                 const trigger = colFilterTriggerRefs.current[filterKey];
//                 if (trigger) {
//                   const rect = trigger.getBoundingClientRect();
//                   const viewportWidth =
//                     window.innerWidth || document.documentElement.clientWidth;
//                   const menuWidth = 286;
//                   let left = rect.left;
//                   if (left + menuWidth + 8 > viewportWidth) {
//                     left = Math.max(8, viewportWidth - menuWidth - 8);
//                   }
//                   setColFilterPortalStyle({
//                     position: "fixed",
//                     top: rect.bottom + 6,
//                     left,
//                     width: menuWidth,
//                     zIndex: 3000,
//                   });
//                 }
//               }
//               return next;
//             });
//           }}
//         >
//           <img
//             className="ms-2 com-custom-table-tag-filter-img"
//             src={base_assets + "images/icons/table-filter-icon.png"}
//             alt=""
//           />
//         </button>
//         {isOpen && createPortal(menuContent, document.body)}
//       </div>
//     );
//   };

//   const downloadexclsheet = async () => {
//     let GetloadingID = loading();
//     try {
//       let postdata = {
//         item: payload?.item ? payload?.item : [],
//         collection: payload?.collection ? payload?.collection : [],
//         metal: payload?.metal ? payload?.metal : [],
//         size: payload?.size ? payload?.size : [],
//         stone: payload?.stone ? payload?.stone : [],
//         productStatus: payload?.productStatus ? payload?.productStatus : [],
//         location: payload?.location ? payload?.location : [],
//         price: payload?.price ? payload?.price : [],
//         search: filtername,
//       };
//       let res = await _Api(postdata, `api/v1/Inventory/my/inventoryExport`);
//       if (res?.code === 200) {
//         Updateloading(t, GetloadingID, res?.message);
//       } else {
//         Updateloading(t, GetloadingID, res?.message, "error");
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const downloadexclpricesheet = async () => {
//     let GetloadingID = loading();
//     try {
//       let postdata = {};
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/my/inventoryPriceExport`,
//       );
//       if (res?.code === 200) {
//         Updateloading(t, GetloadingID, res?.message);
//       } else {
//         Updateloading(t, GetloadingID, res?.message, "error");
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const deallcocation = async (event) => {
//     let GetloadingID = loading();
//     try {
//       const postdata = {
//         po_product_id: product_id,
//         customOrderId: cart_id,
//         type: event,
//       };
//       let res = await _Api(postdata, `api/v1/Inventory/po/deallocation`);
//       if (res.code === 200) {
//         Updateloading(t, GetloadingID, t("Deallocation success!!"));
//         Getmyinventory();
//       } else {
//         Updateloading(t, GetloadingID, t("somthing went wrong"), "error");
//         Getmyinventory();
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   const getSelectedDataList = (selectedList, DataList, dataField = "") => {
//     let data = [];
//     if (selectedList.length > 0) {
//       selectedList.map(function (v) {
//         console.log(v);
//         const filteredDataList = DataList.filter((l, idx) => l.id === v);
//         if (filteredDataList.length > 0) {
//           if (dataField !== "") {
//             data.push(filteredDataList[0][dataField]);
//           } else {
//             data.push(filteredDataList[0]);
//           }
//         }
//         return true;
//       });
//     } else {
//       return [];
//     }

//     return data;
//   };
//   const handleChangefortrace = (obj) => {
//     Getmyinventory(1, limit, obj, "");
//   };

//   const handleClear = (e, obj) => {
//     e.stopPropagation();
//     Getmyinventory(1, limit, obj, "");
//   };
//   const cardTotalAmount = inventorycounts?.total_Amount;
//   const cardTotalLineCount = getStackedPriceLineCount(cardTotalAmount, 3);
//   return (
//     <React.Fragment>
//       <div className="main-body my-inventory-page product-tab-page-padding-top">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
//               <div className="sticky-top-inventory-page" ref={stickyTopRef}>
//               <h1 className="main-body-heading">{t("My Inventory")}</h1>
//               <div className="main-body-top-inventory">
//                 <div className="main-body-top-inventory-status">
//                   <div className="main-body-top-inventory-status-card-1">
//                     <div className="left-side">
//                       <img
//                         src={base_assets + "images/icons/free-stock.png"}
//                         className="inventory-img"
//                         alt="free-stock"
//                       />
//                     </div>
//                     <div className="right-side">
//                       <p className="inventory-name">{t("Free Stock")}</p>
//                       <h2 className="inventory-value stock">
//                         {inventorycounts?.QTY}
//                       </h2>
//                     </div>
//                   </div>
//                   <div className="main-body-top-inventory-status-card-1">
//                     <div className="left-side">
//                       <img
//                         src={base_assets + "images/icons/sku.png"}
//                         className="inventory-img"
//                         alt="sku"
//                       />
//                     </div>
//                     <div className="right-side">
//                       <p className="inventory-name">{t("SKU")}</p>
//                       <h2 className="inventory-value sku">
//                         {inventorycounts?.SKU}
//                       </h2>
//                     </div>
//                   </div>
//                   <div className="main-body-top-inventory-status-card-1">
//                     <div className="left-side">
//                       <img
//                         src={base_assets + "images/icons/value.png"}
//                         className="inventory-img"
//                         alt="value"
//                       />
//                     </div>
//                     <div className="right-side">
//                       <p className="inventory-name">{t("Total Value")}</p>
//                       <h2
//                         className={`inventory-value value tooltip-area-up ${getStatusValueFontClass(
//                           cardTotalLineCount,
//                         )}`.trim()}
//                       >
//                         {renderStackedTotalPrice(cardTotalAmount, 3)}
//                       </h2>
//                     </div>
//                   </div>
//                   <div className="main-body-top-inventory-status-card-1">
//                     <div className="left-side">
//                       <img
//                         src={base_assets + "images/icons/location.png"}
//                         className="inventory-img"
//                         alt="free-stock"
//                       />
//                     </div>
//                     <div className="right-side">
//                       <p className="inventory-name">{t("Locations")}</p>
//                       <h2 className="inventory-value location">
//                         {inventorycounts?.location}
//                       </h2>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="main-body-top-status-bar">
//                 <Select
//                   className="limit-select short mx-3"
//                   options={selectOptions}
//                   value={{ label: limit, value: limit }}
//                   onChange={(e) => {
//                     setLimit(e.value);
//                     getlimit(e.value);
//                   }}
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
//                 />
//                 {/* <button
//                   data-bs-toggle="modal"
//                   data-bs-target="#TraceabilityModal"
//                   onClick={() => {
//                     handleTraceData(1);
//                   }}
//                 >
//                   Trace
//                 </button> */}
//                 <div className="main-body-top-status-bar-filter">
//                   <button
//                     className="main-body-top-status-bar-filter-icon"
//                     data-bs-toggle="modal"
//                     data-bs-target="#filterinventory"
//                   >
//                     <img
//                       className="d-block"
//                       src={base_assets + "/images/icons/search-outline.png"}
//                       alt=""
//                     />
//                   </button>
//                   <input
//                     type="text"
//                     value={filtername}
//                     className="main-body-top-status-bar-filter-input"
//                     placeholder={t("SKU/StockID")}
//                     onKeyPress={(e) =>
//                       e.key === "Enter" && filterbyname(e.target.value)
//                     }
//                     onChange={(e) => {
//                       setFiltername(e.target.value);
//                     }}
//                   />
//                   {filtername ? (
//                     <img
//                       className="main-body-top-status-bar-filter-clear"
//                       src={base_assets + "images/icons/False.png"}
//                       onClick={(e) => {
//                         setFiltername("");
//                         filterbyname("");
//                       }}
//                       alt=""
//                     />
//                   ) : (
//                     ""
//                   )}
//                   <button
//                     onClick={filterbyname}
//                     className="main-body-top-status-bar-filter-search"
//                   >
//                     <i className="fa fa-search" aria-hidden="true" />
//                   </button>
//                 </div>
//                 <div className="main-body-top-status-bar-multi-date-picker">
//                   <button className="print-export-dropdown-selected-icon d-none">
//                     <img
//                       src={base_assets + "images/icons/printer-icon.png"}
//                       alt=""
//                     />
//                   </button>
//                   {/* <span className="status-inventory-stock-btn" data-bs-toggle="modal" data-bs-target="#barcodeModal" >
//                     <i className="fa fa-barcode"></i>
//                   </span>  */}
//                   <div className="status-inventory">
//                     <div className="status-inventory-stock">
//                       <div className="tracefilter-container">
//                         <input
//                           className="tracefilter-checkbox d-none"
//                           type="checkbox"
//                           id="allocated-checkbox"
//                           checked={payload?.allocated}
//                         />

//                         <label
//                           htmlFor="allocated-checkbox"
//                           className={`tracefilter-label tooltip-area-up ${
//                             payload?.allocated ? "checked" : ""
//                           }`}
//                         >
//                           <img
//                             className="img"
//                             src={allocatableimg}
//                             onClick={() =>
//                               handleChangefortrace({ allocated: true })
//                             }
//                             alt="Link icon"
//                           />
//                           {payload?.allocated ? (
//                             <span className="tracefilter-number">
//                               {invCount || 0}
//                             </span>
//                           ) : (
//                             ""
//                           )}

//                           {payload?.allocated && (
//                             <button
//                               className="tracefilter-clearbtn"
//                               onClick={(e) =>
//                                 handleClear(e, { allocated: false })
//                               }
//                               title="Clear Filter"
//                             >
//                               x
//                             </button>
//                           )}
//                           <span className="tooltip-area-up-text">
//                             Allocated
//                           </span>
//                         </label>
//                       </div>
//                       {generalsettings?.data?.generalsetup?.traceability ===
//                       "1" ? (
//                         <div className="tracefilter-container">
//                           <input
//                             type="checkbox"
//                             id="tracefilter-checkbox"
//                             checked={payload?.traced}
//                             className="tracefilter-checkbox d-none"
//                           />

//                           <label
//                             htmlFor="tracefilter-checkbox"
//                             className={`tracefilter-label tooltip-area-up ${
//                               payload?.traced ? "checked" : ""
//                             }`}
//                           >
//                             <img
//                               src={traceimg}
//                               alt="Trace"
//                               className="tracefilter-icon"
//                               onClick={() =>
//                                 handleChangefortrace({ traced: true })
//                               }
//                             />
//                             {payload?.traced ? (
//                               <span className="tracefilter-number">
//                                 {invCount || 0}
//                               </span>
//                             ) : (
//                               ""
//                             )}

//                             {payload?.traced && (
//                               <button
//                                 className="tracefilter-clearbtn"
//                                 onClick={(e) =>
//                                   handleClear(e, { traced: false })
//                                 }
//                                 title="Clear Filter"
//                               >
//                                 x
//                               </button>
//                             )}
//                             <span className="tooltip-area-up-text">
//                               Traceability
//                             </span>
//                           </label>
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                       <div
//                         ref={viewDropdownRef}
//                         style={{ position: "relative" }}
//                       >
//                         <button
//                           type="button"
//                           onClick={() => {
//                             if (!viewDropdownOpen) {
//                               updateViewDropdownPosition();
//                             }
//                             setViewDropdownOpen((o) => !o);
//                           }}
//                           style={{
//                             background: "transparent",
//                             cursor: "pointer",
//                             lineHeight: 1,
//                             display: "flex",
//                             alignItems: "center",
//                           }}
//                         >
//                           {viewMode === "grid5" && (
//                             <img src={grid5img} alt="5 columns" />
//                           )}
//                           {viewMode === "grid4" && (
//                             <img src={grid4img} alt="4 columns" />
//                           )}
//                           {viewMode === "table" && (
//                             <img src={tablerowimg} alt="table" />
//                           )}
//                         </button>
//                         {viewDropdownOpen &&
//                           createPortal(
//                           <div
//                             ref={viewDropdownMenuRef}
//                             style={viewDropdownPortalStyle}
//                           >
//                             <button
//                               type="button"
//                               title={t("5 columns")}
//                               onClick={() => {
//                                 handleViewModeChange("grid5");
//                                 setViewDropdownOpen(false);
//                               }}
//                               style={{
//                                 padding: "6px 8px",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 background:
//                                   viewMode === "grid5"
//                                     ? "#5cc7c1"
//                                     : "transparent",
//                                 cursor: "pointer",
//                                 lineHeight: 1,
//                                 display: "flex",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <img src={grid5img} alt="5 columns" />
//                             </button>
//                             <button
//                               type="button"
//                               title={t("4 columns")}
//                               onClick={() => {
//                                 handleViewModeChange("grid4");
//                                 setViewDropdownOpen(false);
//                               }}
//                               style={{
//                                 padding: "6px 8px",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 background:
//                                   viewMode === "grid4"
//                                     ? "#5cc7c1"
//                                     : "transparent",
//                                 cursor: "pointer",
//                                 lineHeight: 1,
//                                 display: "flex",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <img src={grid4img} alt="4 columns" />
//                             </button>
//                             <button
//                               type="button"
//                               title={t("Table view")}
//                               onClick={() => {
//                                 handleViewModeChange("table");
//                                 setViewDropdownOpen(false);
//                               }}
//                               style={{
//                                 padding: "6px 8px",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 background:
//                                   viewMode === "table"
//                                     ? "#5cc7c1"
//                                     : "transparent",
//                                 cursor: "pointer",
//                                 lineHeight: 1,
//                                 display: "flex",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <img src={tablerowimg} alt="table" />
//                             </button>
//                           </div>,
//                           document.body
//                         )}
//                       </div>

//                       {rfidIntegrate && (
//                         <Link
//                           // type="button"
//                           // className="status-inventory-stock-btn"
//                           className="tooltip-area-up"
//                           onClick={() => {
//                             !syncRfidLoading && handleSyncRfid();
//                           }}
//                           disabled={syncRfidLoading}
//                           style={{
//                             opacity: syncRfidLoading ? 0.7 : 1,
//                             cursor: syncRfidLoading ? "not-allowed" : "pointer",
//                           }}
//                         >
//                           {syncRfidLoading ? <RFIDIcon /> : <RFIDIcon />}
//                           <span
//                             className="tooltip-area-up-text"
//                             style={{
//                               textWrapMode: "wrap",
//                               fontSize: "12px",
//                               width: "250px",
//                               whiteSpace: "normal",
//                             }}
//                           >
//                             RFID
//                             <br />
//                             <span style={{ fontSize: "11px" }}>
//                               {
//                                 "Apply filters to select the products you want to sync, then click Sync. If no filters are applied, all inventory products will be synced."
//                               }
//                             </span>
//                           </span>
//                           {/* {syncRfidLoading ? t("Syncing...") : t("Sync RFID")} */}
//                         </Link>
//                       )}
//                       <Link
//                         to="/app/inventory/quickview"
//                         className="tooltip-area-up"
//                         state={{
//                           SKU: getSelectedDataList(
//                             Selectlist,
//                             inventorylist,
//                             "SKU",
//                           ),
//                         }}
//                       >
//                         <img
//                           style={{ width: "26px", height: "22px" }}
//                           src={quickviewinvsvg}
//                           alt=""
//                         />
//                         <span className="tooltip-area-up-text">Quick View</span>
//                       </Link>

//                       <Link
//                         className={
//                           onlyTransfer || !showoption
//                             ? "noshow-inventory-status status-inventory-stock-btn"
//                             : showpos.length === 1
//                               ? "show-inventory-status status-inventory-stock-btn"
//                               : "status-inventory-stock-btn noshow-inventory-status"
//                         }
//                         to="/app/inventory/posorder"
//                         state={{ selectedid: Selectlist }}
//                       >
//                         <img
//                           src={
//                             base_assets +
//                             "images/icons/danger-calender-icon.png"
//                           }
//                           alt=""
//                         />
//                         {t("POS Order")}
//                       </Link>
//                       <Link
//                         to="/app/inventory/createreserves"
//                         state={{ datalist: Selectlist }}
//                         className={
//                           parmissiondatashow?.reserve_list?.Add
//                             ? (showoption || Selectlist?.length) &&
//                               !onlyTransfer
//                               ? "show-inventory-status status-inventory-stock-btn"
//                               : "noshow-inventory-status status-inventory-stock-btn"
//                             : "d-none"
//                         }
//                       >
//                         <img
//                           src={
//                             base_assets +
//                             "images/icons/yellow-calender-icon.png"
//                           }
//                           alt=""
//                         />
//                         {t("Reserve")}
//                       </Link>
//                       <Link
//                         to="/app/inventory/createTransfer"
//                         state={{
//                           createlist: transferlist,
//                           hidelocationid: selectedlocation,
//                           showwarehouseid: selectedwarehouse,
//                           myinventory: true,
//                         }}
//                         className={
//                           transferlist?.length
//                             ? showtransfer
//                               ? "status-inventory-stock-btn"
//                               : "noshow-inventory-status status-inventory-stock-btn"
//                             : "noshow-inventory-status status-inventory-stock-btn"
//                         }
//                       >
//                         <img
//                           src={base_assets + "images/icons/stock-fast.png"}
//                           alt=""
//                         />
//                         {t("Transfer")}
//                       </Link>
//                     </div>
//                   </div>
//                   <div className="main-body-top-status-bar-print-export-dropdown dropdown">
//                     <button
//                       className="btn dropdown-toggle"
//                       type="button"
//                       id="dropdownMenuButton1"
//                       data-bs-toggle="dropdown"
//                       aria-expanded="false"
//                     >
//                       <img
//                         src={base_assets + "images/icons/ellipsis-circular.png"}
//                         alt=""
//                       />
//                     </button>
//                     <ul
//                       className="dropdown-menu"
//                       aria-labelledby="dropdownMenuButton1"
//                     >
//                       <li
//                         className={
//                           parmissiondatashow?.my_inventory?.Print
//                             ? "dropdown-item print-dropdown-item"
//                             : "d-none"
//                         }
//                         onClick={(e) => {
//                           getprintmyinventary(e.target.value);
//                         }}
//                       >
//                         <div className="dropdown-item-img">
//                           <img
//                             src={base_assets + "images/icons/printer-icon.png"}
//                             alt=""
//                           />
//                         </div>
//                         <span>{t("print")}</span>
//                       </li>
//                       <li
//                         className="dropdown-item"
//                         onClick={(e) => {
//                           downloadexclsheet();
//                         }}
//                       >
//                         <div className="dropdown-item-img">
//                           <img
//                             src={base_assets + "images/icons/export-x-icon.png"}
//                             alt=""
//                           />
//                         </div>
//                         <span>{t("export")}</span>
//                       </li>
//                       <li
//                         className="dropdown-item"
//                         data-bs-toggle="modal"
//                         data-bs-target="#socialModal"
//                         onClick={() => getshareinventary()}
//                       >
//                         <div className="dropdown-item-img">
//                           <img
//                             src={base_assets + "images/icons/share-icon.png"}
//                             alt=""
//                           />
//                         </div>
//                         <span>{t("share")}</span>
//                       </li>
//                       <li
//                         className="dropdown-item"
//                         data-bs-toggle="modal"
//                         data-bs-target="#columnModal"
//                       >
//                         <div className="dropdown-item-img">
//                           <img
//                             src={base_assets + "images/icons/column-icon.png"}
//                             alt=""
//                           />
//                         </div>
//                         <span>{t("column")}</span>
//                       </li>
//                       <li
//                         className="dropdown-item"
//                         onClick={(e) => {
//                           downloadexclpricesheet();
//                         }}
//                       >
//                         <div className="dropdown-item-img">
//                           <img
//                             src={base_assets + "images/icons/export-x-icon.png"}
//                             alt=""
//                           />
//                         </div>
//                         <span>{t("Price Export")}</span>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//               </div>
//               <div
//                 className="main-body-main-table-wrap position-relative"
//                 style={{
//                   maxWidth: "100%",
//                   overflow: "visible",
//                 }}
//               >
//                 {viewMode !== "table" && (
//                   <div
//                     className={`row g-3 ${viewMode === "grid5" ? "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5" : "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4"}`}
//                   >
//                     {!datalodaer && inventorylist?.length
//                       ? inventorylist.map((result, key) => (
//                           <div className="col" key={key}>
//                             <div
//                               className={
//                                 result?.rowclass === "row-inactive"
//                                   ? "row-inactive"
//                                   : ""
//                               }
//                               style={{
//                                 position: "relative",
//                                 zIndex: 0,
//                                 background: "#FFFFFF",
//                                 boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
//                                 borderRadius: "4px",
//                               }}
//                             >
//                               {/* Image area — taller than previous 307:200 for grid cards */}
//                               <div
//                                 style={{
//                                   position: "relative",
//                                   width: "100%",
//                                   paddingBottom: "78%",
//                                   background: "#D9D9D9",
//                                   overflow: "hidden",
//                                   borderRadius: "4px 4px 0 0",
//                                 }}
//                               >
//                                 <img
//                                   src={
//                                     result?.main_image ||
//                                     base_assets +
//                                       "images/icon/camera_profile.png"
//                                   }
//                                   alt=""
//                                   style={{
//                                     position: "absolute",
//                                     inset: 0,
//                                     width: "100%",
//                                     height: "100%",
//                                     cursor: "pointer",
//                                   }}
//                                   onError={(e) => {
//                                     e.target.onerror = null;
//                                     e.target.src =
//                                       "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
//                                   }}
//                                   onClick={() => setImageid(result?.product_id)}
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#ProductViewModal"
//                                 />
//                               </div>
//                               {/* Checkbox — top-left. Rendered as a sibling of the
//                               (overflow:hidden) image wrapper, not inside it,
//                               so the "Under Adjustment" tooltip isn't clipped. */}
//                               <HeldCheckbox
//                                 result={result}
//                                 wrapperStyle={{
//                                   position: "absolute",
//                                   left: "16px",
//                                   top: "13px",
//                                   zIndex: 2,
//                                 }}
//                                 wrapperClassName={
//                                   result?.rowclass === "row-inactive" ||
//                                   result?.status_type === "transit" ||
//                                   result?.isnottransferable === true ||
//                                   result?.isnottransferable === "true" ||
//                                   result?.is_adjustment_held
//                                     ? "com-check checkbox-disabled"
//                                     : "com-check"
//                                 }
//                                 inputClassName="inventorytablecheck gisClassTh"
//                                 onChange={(e) => handleChange(e)}
//                                 t={t}
//                               />
//                               {/* Top-right icon group — outside image div so tooltip is not clipped */}
//                               <div
//                                 style={{
//                                   position: "absolute",
//                                   right: "16px",
//                                   top: "13px",
//                                   zIndex: 3,
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "2px",
//                                 }}
//                               >
//                                 {result?.traceability_on && (
//                                   <img
//                                     src={traceimg}
//                                     alt="trace"
//                                     style={{
//                                       width: "32px",
//                                       height: "32px",
//                                       cursor: "pointer",
//                                     }}
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#TraceabilityModal"
//                                     onClick={() => handleTraceData(key)}
//                                   />
//                                 )}
//                                 {result?.pos_Qty !== 0 &&
//                                 result?.pos?.order_type === "repair_order" ? (
//                                   <div
//                                     className="tooltip-area-up"
//                                     style={{ lineHeight: 0 }}
//                                   >
//                                     <img
//                                       src={
//                                         base_assets +
//                                         "images/icons/user-purple.png"
//                                       }
//                                       alt="repair order"
//                                       style={{ width: "20px", height: "20px" }}
//                                     />
//                                     <span className="tooltip-area-up-text">
//                                       {result?.customer_name}
//                                       {result?.customer_name ? <br /> : ""}
//                                       {result?.POS_Order}
//                                       {result?.POS_Order ? <br /> : ""}
//                                       {result?.delivery_date}
//                                     </span>
//                                   </div>
//                                 ) : result?.pos_Qty !== 0 ? (
//                                   <div
//                                     className="tooltip-area-up"
//                                     style={{ lineHeight: 0 }}
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#allocation-listedModal"
//                                   >
//                                     <img
//                                       src={
//                                         base_assets +
//                                         "images/icons/user-red.png"
//                                       }
//                                       alt="custom order"
//                                       style={{ width: "20px", height: "20px" }}
//                                     />
//                                     <span className="tooltip-area-up-text">
//                                       {result?.customer_name}
//                                       {result?.customer_name ? <br /> : ""}
//                                       {result?.POS_Order}
//                                       {result?.POS_Order ? <br /> : ""}
//                                       {result?.delivery_date}
//                                     </span>
//                                   </div>
//                                 ) : null}
//                                 {result?.allocatable && (
//                                   <img
//                                     src={allocatableimg}
//                                     alt=""
//                                     style={{ width: "32px", height: "32px" }}
//                                   />
//                                 )}
//                               </div>
//                               {/* Info section */}
//                               <div
//                                 style={{
//                                   padding: "14px 16px",
//                                   display: "flex",
//                                   flexDirection: "column",
//                                   justifyContent: "space-between",
//                                   minHeight: "107.78px",
//                                 }}
//                               >
//                                 <div>
//                                   <p
//                                     style={{
//                                       margin: 0,
//                                       fontFamily: "Segoe UI, sans-serif",
//                                       fontSize: "16px",
//                                       lineHeight: "21px",
//                                       color: "#A4A4A4",
//                                       overflow: "hidden",
//                                       textOverflow: "ellipsis",
//                                       whiteSpace: "nowrap",
//                                       cursor: "pointer",
//                                     }}
//                                     onClick={() => setOneproduct(result)}
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#ProductInfoModal"
//                                   >
//                                     {result?.name || result?.item_name || ""}
//                                   </p>
//                                   <div
//                                     style={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       gap: "6px",
//                                       marginTop: "4px",
//                                       overflow: "hidden",
//                                     }}
//                                   >
//                                     <p
//                                       style={{
//                                         margin: 0,
//                                         fontFamily: "Segoe UI, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "14px",
//                                         lineHeight: "19px",
//                                         color: "#2A2A2A",
//                                         overflow: "hidden",
//                                         textOverflow: "ellipsis",
//                                         whiteSpace: "nowrap",
//                                         flexShrink: 0,
//                                         maxWidth: "50%",
//                                       }}
//                                     >
//                                       {result?.SKU || ""}
//                                     </p>
//                                     {result?.stock_id && (
//                                       <>
//                                         <span
//                                           style={{
//                                             color: "#E5E5E5",
//                                             flexShrink: 0,
//                                           }}
//                                         >
//                                           |
//                                         </span>
//                                         <p
//                                           style={{
//                                             margin: 0,
//                                             fontFamily: "Segoe UI, sans-serif",
//                                             fontWeight: 400,
//                                             fontSize: "14px",
//                                             lineHeight: "19px",
//                                             color: "#2A2A2A",
//                                             overflow: "hidden",
//                                             textOverflow: "ellipsis",
//                                             whiteSpace: "nowrap",
//                                           }}
//                                         >
//                                           {result?.stock_id}
//                                         </p>
//                                       </>
//                                     )}
//                                     {result?.location_name && (
//                                       <>
//                                         <span
//                                           style={{
//                                             color: "#E5E5E5",
//                                             flexShrink: 0,
//                                           }}
//                                         >
//                                           |
//                                         </span>
//                                         <p
//                                           style={{
//                                             margin: 0,
//                                             fontFamily: "Segoe UI, sans-serif",
//                                             fontWeight: 400,
//                                             fontSize: "14px",
//                                             lineHeight: "19px",
//                                             color: "#2A2A2A",
//                                             overflow: "hidden",
//                                             textOverflow: "ellipsis",
//                                             whiteSpace: "nowrap",
//                                           }}
//                                         >
//                                           {result?.location_name}
//                                         </p>
//                                       </>
//                                     )}
//                                   </div>
//                                 </div>
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     marginTop: "10px",
//                                   }}
//                                 >
//                                   <span
//                                     style={{
//                                       fontFamily: "Segoe UI, sans-serif",
//                                       fontWeight: 400,
//                                       fontSize: "18px",
//                                       lineHeight: "24px",
//                                       color: "#2A2A2A",
//                                     }}
//                                   >
//                                     {result?.price || ""}
//                                   </span>
//                                   <div
//                                     className={`status-dot ${getStatusDotClass(result?.status_type)} tooltip-area-up ms-2`}
//                                     style={{
//                                       width: "13px",
//                                       height: "13px",
//                                       flexShrink: 0,
//                                     }}
//                                   >
//                                     <span className="tooltip-area-up-text">
//                                       {t(getStatusLabel(result?.status_type))}
//                                     </span>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       : ""}
//                   </div>
//                 )}
//                 {viewMode === "table" && (
//                   <>
//                   <div className="my-inventory-sticky-thead">
//                     <div
//                       className="my-inventory-table-hscroll my-inventory-table-hscroll--head"
//                       ref={tableHeadScrollRef}
//                       onScroll={() => syncInventoryTableScroll("head")}
//                     >
//                       <table
//                         ref={tableHeadTableRef}
//                         className="stripe row-border order-column common-table table-striped main-table my-inventory-head-table"
//                       >
//                     <thead>
//                       <tr>
//                         <th
//                           ref={(el) => (stickyThRefs.current[0] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[0],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           <div className="com-check">
//                             <input
//                               checked={SelectAllStatus}
//                               id="th_comman_checkbox"
//                               onClick={(e) =>
//                                 setSelectAllStatus(e.target.checked)
//                               }
//                               className="inventorytableHead_main"
//                               data-select="inventorytableHead_main"
//                               type="checkbox"
//                             />
//                             <label
//                               htmlFor="th_comman_checkbox"
//                               className="com-check-label"
//                             />
//                           </div>
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[1] = el)}
//                           className="fixed-side"
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[1],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           #
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[2] = el)}
//                           className="fixed-side"
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[2],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("Img")}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[3] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[3],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("SKU")}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[4] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[4],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("Item")}
//                           {renderColFilterDropdown("item", colDropdownRefItem)}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[5] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[5],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("Collection")}
//                           {renderColFilterDropdown(
//                             "collection",
//                             colDropdownRefCollection,
//                           )}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[6] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[6],
//                             zIndex: 3,
//                             background: "#fff",
//                             boxShadow: "3px 0 5px -2px rgba(0,0,0,0.15)",
//                           }}
//                         >
//                           {t("Metal")}
//                           {renderColFilterDropdown(
//                             "metal",
//                             colDropdownRefMetal,
//                           )}
//                         </th>
//                         <th>
//                           {t("Stone")}
//                           {renderColFilterDropdown(
//                             "stone",
//                             colDropdownRefStone,
//                           )}
//                         </th>
//                         <th>
//                           {t("Size")}
//                           {renderColFilterDropdown("size", colDropdownRefSize)}
//                         </th>
//                         <th>{t("Stock ID")}</th>
//                         <th></th>
//                         <th></th>
//                         <th>{t("Qty")}</th>
//                         <th>{t("Price")}</th>
//                         <th>{t("Aging")}</th>
//                         <th>
//                           {t("Location")}
//                           {renderColFilterDropdown(
//                             "location",
//                             colDropdownRefLocation,
//                           )}
//                         </th>
//                         <th className="text-center">
//                           {t("Status")}
//                           {renderColFilterDropdown(
//                             "status",
//                             colDropdownRefStatus,
//                           )}
//                         </th>
//                         <th className="text-center">{t("POS Order")}</th>
//                         <th className="text-center">{t("Customer")}</th>
//                         <th className="text-center">{t("Delivery Date")}</th>
//                         <th className="text-center">{t("Due Days")}</th>
//                         <th>{t("Remark")}</th>
//                       </tr>
//                     </thead>
//                       </table>
//                     </div>
//                   </div>
//                   <div
//                     className="my-inventory-table-hscroll my-inventory-table-hscroll--body"
//                     ref={tableBodyScrollRef}
//                     onScroll={() => syncInventoryTableScroll("body")}
//                   >
//                   <table
//                     id="my_inventory"
//                     ref={tableBodyTableRef}
//                     className="stripe row-border order-column common-table table-striped main-table w-100"
//                   >
//                     <tbody>
//                       <>
//                         {!datalodaer && inventorylist?.length
//                           ? inventorylist.map((result, key) => {
//                               return (
//                                 <tr
//                                   key={key}
//                                   className={
//                                     result?.rowclass ? result.rowclass : ""
//                                   }
//                                 >
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[0],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     <HeldCheckbox
//                                       result={result}
//                                       wrapperClassName={
//                                         result?.rowclass === "row-inactive" ||
//                                         result?.status_type === "transit" ||
//                                         result?.isnottransferable === true ||
//                                         result?.isnottransferable === "true" ||
//                                         result?.is_adjustment_held
//                                           ? "com-check checkbox-disabled"
//                                           : "com-check"
//                                       }
//                                       inputClassName="inventorytablecheck inventorytableHead gisClassTh"
//                                       onChange={(e) => handleChange(e)}
//                                       t={t}
//                                     />
//                                   </td>
//                                   <td
//                                     className="fixed-side"
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[1],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     {" "}
//                                     {parseInt(key + getSkipNumbers + 1)}
//                                   </td>
//                                   <td
//                                     className="table-pro-img"
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[2],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                     onClick={() =>
//                                       setImageid(result?.product_id)
//                                     }
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#ProductViewModal"
//                                   >
//                                     <img
//                                       src={
//                                         result?.main_image
//                                           ? result?.main_image
//                                           : base_assets +
//                                             "images/icon/camera_profile.png"
//                                       }
//                                       alt=""
//                                     />
//                                   </td>
//                                   <td
//                                     className="col-highlight link-color cursor-pointer"
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[3],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                     onClick={() => {
//                                       setOneproduct(result);
//                                     }}
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#ProductInfoModal"
//                                   >
//                                     {result?.SKU ? result?.SKU : ""}
//                                   </td>
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[4],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     <div className="tooltip-area-up">
//                                       {result?.item_code
//                                         ? result?.item_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.item_name
//                                           ? result?.item_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[5],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     <div className="tooltip-area-up">
//                                       {result?.collection_code
//                                         ? result?.collection_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.collection_name
//                                           ? result?.collection_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[6],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                       boxShadow:
//                                         "3px 0 5px -2px rgba(0,0,0,0.15)",
//                                     }}
//                                   >
//                                     <div className="tooltip-area-up">
//                                       {result?.metal_code
//                                         ? result?.metal_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.metal_name
//                                           ? result?.metal_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td className="col-highlight">
//                                     <div className="tooltip-area-up">
//                                       {result?.stone_code
//                                         ? result?.stone_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.stone_name
//                                           ? result?.stone_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.size_name ? result?.size_name : ""}
//                                   </td>
//                                   {result?.status_stock_id === "stock" ? (
//                                     <td className="light-blue-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id === "transit" ? (
//                                     <td className="status-green-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id ===
//                                     "warehouse" ? (
//                                     <td className="status-gray-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id === "reserve" ? (
//                                     <td className="yellow-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}{" "}
//                                           {result?.customer_name ? <br /> : ""}{" "}
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id ===
//                                     "repair_order" ? (
//                                     <td className="purple-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}
//                                           {result?.customer_name ? <br /> : ""}
//                                           {result?.POS_Order}
//                                           <br />
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id ===
//                                     "custom_order" ? (
//                                     <td className="danger-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}
//                                           {result?.customer_name ? <br /> : ""}
//                                           {result?.POS_Order}
//                                           <br />
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : (
//                                     ""
//                                   )}
//                                   <td className="col-highlight">
//                                     {result?.traceability_on ? (
//                                       <img
//                                         src={traceimg}
//                                         alt="trace_on"
//                                         data-bs-toggle="modal"
//                                         data-bs-target="#TraceabilityModal"
//                                         onClick={() => handleTraceData(key)}
//                                       />
//                                     ) : (
//                                       ""
//                                     )}
//                                   </td>
//                                   <td
//                                     className="sku-col table_btn_expand_col col-highlight"
//                                     onClick={() => {
//                                       setProduct_id(result?.id);
//                                       setCart_id(result?.pos?.cart_id);
//                                     }}
//                                   >
//                                     {result?.allocatable === true ? (
//                                       <div className="td-icons-wrap m-3 d-inline-block">
//                                         <div className="td-icons-wrap-link">
//                                           <img
//                                             className="img"
//                                             src={
//                                               base_assets +
//                                               "images/icons/link-icon.svg"
//                                             }
//                                             alt=""
//                                           />
//                                         </div>
//                                       </div>
//                                     ) : (
//                                       ""
//                                     )}
//                                     <div className="td-icons-wrap-user d-inline-block">
//                                       {result?.pos_Qty !== 0 &&
//                                       result?.pos?.order_type ===
//                                         "repair_order" ? (
//                                         <div className="tooltip-area-up">
//                                           <div className="td-icons-wrap-user d-inline-block">
//                                             <img
//                                               className="img"
//                                               src={
//                                                 base_assets +
//                                                 "images/icons/user-purple.png"
//                                               }
//                                               alt=""
//                                             />
//                                           </div>
//                                           <span className="tooltip-area-up-text">
//                                             {result?.customer_name}
//                                             {result?.customer_name ? (
//                                               <br />
//                                             ) : (
//                                               ""
//                                             )}
//                                             {result?.POS_Order}
//                                             <br />
//                                             {result?.delivery_date}
//                                           </span>
//                                         </div>
//                                       ) : result?.pos_Qty !== 0 ? (
//                                         <div
//                                           className="tooltip-area-up"
//                                           data-bs-toggle="modal"
//                                           data-bs-target="#allocation-listedModal"
//                                         >
//                                           <div className="td-icons-wrap-user d-inline-block">
//                                             <img
//                                               className="img"
//                                               src={
//                                                 base_assets +
//                                                 "images/icons/user-red.png"
//                                               }
//                                               alt=""
//                                             />
//                                           </div>
//                                           <span className="tooltip-area-up-text">
//                                             {result?.customer_name}
//                                             {result?.customer_name ? (
//                                               <br />
//                                             ) : (
//                                               ""
//                                             )}
//                                             {result?.POS_Order}
//                                             <br />
//                                             {result?.delivery_date}
//                                           </span>
//                                         </div>
//                                       ) : (
//                                         ""
//                                       )}
//                                     </div>
//                                     <div className="td-icons-wrap-user d-inline-block">
//                                       <div className="tooltip-area-up">
//                                         {result?.status_type === "  " ? (
//                                           <div className="td-icons-wrap-user d-inline-block">
//                                             <img
//                                               className="img"
//                                               src={
//                                                 base_assets +
//                                                 "images/icons/user-yellow.png"
//                                               }
//                                               alt=""
//                                             />
//                                           </div>
//                                         ) : (
//                                           ""
//                                         )}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}
//                                           {result?.customer_name ? <br /> : ""}
//                                           <br />
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </div>
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.po_QTY ? result?.po_QTY : 0}
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.price ? result?.price : ""}
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.aging ? result?.aging : "0"}
//                                   </td>
//                                   <td className="location-td col-highlight">
//                                     {" "}
//                                     <span className="link-color">
//                                       {" "}
//                                       {result?.location_name
//                                         ? result?.location_name
//                                         : ""}{" "}
//                                     </span>{" "}
//                                     <span className="text-center location-td-sub">
//                                       {result?.warehouse_location_name
//                                         ? result?.warehouse_location_name
//                                         : ""}
//                                     </span>{" "}
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.status_type === "stock" ? (
//                                       <div className="status-dot light-blue-bg  tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Stock")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type === "transit" ? (
//                                       <div className="status-dot green-bg  tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Transit")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type === "warehouse" ? (
//                                       <div className="status-dot status-gray-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Warehouse")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type === "reserve" ? (
//                                       <div className="status-dot yellow-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Reserve")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type ===
//                                       "repair_order" ? (
//                                       <div className="status-dot purple-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Repair Order")}
//                                         </span>
//                                       </div>
//                                     ) : (
//                                       <div className="status-dot danger-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Custom Order")}
//                                         </span>
//                                       </div>
//                                     )}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.POS_Order ? result?.POS_Order : ""}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.customer_name
//                                       ? result?.customer_name
//                                       : ""}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.delivery_date
//                                       ? result?.delivery_date
//                                       : ""}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.due_days ? result?.due_days : ""}
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.remark ? result?.remark : "-"}
//                                   </td>
//                                 </tr>
//                               );
//                             })
//                           : ""}
//                       </>
//                     </tbody>
//                     <tfoot>
//                       {!datalodaer && (
//                         <tr>
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td>{datatotal?.total_qty ?? 0}</td>
//                           <td>
//                             {renderStackedTotalPrice(datatotal?.total_price)}
//                           </td>
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                         </tr>
//                       )}
//                     </tfoot>
//                   </table>
//                   </div>
//                   </>
//                 )}
//                 {datalodaer && <TableLoader />}
//               </div>
//             </div>
//             {inventorylist.length > 0 ? (
//               <Pagination
//                 total={totalPages}
//                 current={currentPage}
//                 pagination={(crPage) => handlePaginations(crPage)}
//               />
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//         <SocialModal shareUrl={socialurl} shareloader={shareloader} />
//         <BarcodeModal selectList={Selectlist} inventoryList={inventorylist} />
//         <ProductModal
//           data_product={getoneproduct}
//           setOneproduct={setOneproduct}
//           editproduct_submit={editproduct_submit}
//           canEditProductInfo={
//             parmissiondatashow?.edit_inv_prod_info?.Edit === 1
//           }
//         />
//         <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
//         <Filtermodal
//           submitfiltter={Getmyinventory}
//           limit={limit}
//           custom_filter_enable={true}
//           filterChecked={activeFilters}
//           setFilterChecked={setActiveFilters}
//           onClearAll={handleClearAllFilters}
//         />
//         <div
//           className="modal fade common-modal common-modal-danger"
//           id="allocation-listedModal"
//           tabIndex={-1}
//           aria-labelledby="allocation-listedModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-body">
//                 <img
//                   className="common-modal-exclamation-img"
//                   src={base_assets + "images/icons/exclamation-mark-red.png"}
//                   alt=""
//                 />
//                 <p className="modal-content-text">
//                   {t("Are you sure you want to Free this item ?")}
//                 </p>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn modal-content-no"
//                   data-bs-dismiss="modal"
//                   onClick={(e) => deallcocation("NO")}
//                 >
//                   {t("Order Close")}
//                 </button>
//                 <button
//                   type="button"
//                   className="btn modal-content-yes"
//                   data-bs-dismiss="modal"
//                   onClick={(e) => deallcocation("YES")}
//                 >
//                   {t("Deallocate")}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <TraceabilityModal
//         t={t}
//         traceData={traceData}
//         traceDetail={traceDetail}
//       />
//       <ConfirmationModel></ConfirmationModel>
//     </React.Fragment>
//   );
// };
// export default MyInventory;




import React, { useRef, useState, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { _Api } from "../api/_call";
import ConfirmationModel from "../common/modules/confirmationmodel";
import HeldCheckbox from "../common/modules/HeldCheckbox";
import "rc-slider/assets/index.css";
import ProductModal from "../common/modules/ProductModal";
import ProductImageSliderModal from "../common/modules/productImageslider";
import { Pagination } from "../common/Pagination";
import Filtermodal from "../common/modules/Filtermodal";
import SocialModal from "../common/modules/SocialModal/SocialModal";
import { error, loading, Updateloading } from "../common/helpers/toastify";
import ExportOptionModal from "../common/ExportOptionModal";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useSelector } from "react-redux";
import TableLoader from "../../admin/common/TableLoader";
import BarcodeModal from "../common/modules/BarcodeModal";
import product_design from "../../assets/images/product_design.svg";
import chain_origin from "../../assets/images/chain_origin.svg";
import diamond_mine from "../../assets/images/diamond_mine.svg";
import metal_origin from "../../assets/images/metal_origin.svg";
import handcrafting from "../../assets/images/handcrafting.svg";
import qc_shipping from "../../assets/images/qc_shipping.svg";
import chainrelated from "../../assets/images/chainrelated.png";
import diamondrelated from "../../assets/images/diamondrelated.png";
import TraceabilityModal from "./TraceabilityModal";
import traceimg from "../../assets/images/TraceItem_diamond.svg";
import { canSelectFreeStockRows, isFreeStockRow } from "../common/helpers/canSelectAllRows";
import allocatableimg from "../../assets/images/allocatable-1.svg";
import grid4img from "../../assets/images/grid-4.png";
import grid5img from "../../assets/images/grid-5.png";
import tablerowimg from "../../assets/images/table-row.png";
import quickviewinvsvg from "../../assets/images/quickviewinv.svg";
import "./inventory.scss";
import { buildInventoryProductUpdatePayload } from "../../Helper/inventoryProductPayload";
import RFIDIcon from "Icons/RFIDIcon";

const getStackedPriceLineCount = (totalPrice, maxLines) => {
  if (!totalPrice) return 0;
  const parts = String(totalPrice)
    .split("+")
    .map((part) => part.trim())
    .filter(Boolean);
  const count = parts.length;
  if (!maxLines) return count;
  return Math.min(count, maxLines);
};

const getStatusValueFontClass = (lineCount) => {
  if (lineCount >= 3) return "inventory-value--3-lines";
  if (lineCount === 2) return "inventory-value--2-lines";
  return "";
};

const renderStackedTotalPrice = (totalPrice, maxLines) => {
  if (!totalPrice) return "";
  const parts = String(totalPrice)
    .split("+")
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length <= 1) return totalPrice;
  const visibleParts = maxLines ? parts.slice(0, maxLines) : parts;
  return (
    <span className="my-inventory-total-price">
      {visibleParts.map((part, index) => (
        <span
          key={`${part}-${index}`}
          className="my-inventory-total-price__line"
        >
          {part}
        </span>
      ))}
    </span>
  );
};

const applyInventoryRowLock = (list, locationId, warehouseId) => {
  const hasLocationLock = Boolean(locationId);
  const lockWarehouse =
    warehouseId && warehouseId !== "null" ? warehouseId : "";
  return (list || []).map((row) => {
    if (!hasLocationLock) {
      return { ...row, rowclass: "" };
    }
    if (row?.location_id !== locationId) {
      return { ...row, rowclass: "row-inactive" };
    }
    const rowWarehouse = row?.warehouse_id ? row.warehouse_id : "";
    if (lockWarehouse && rowWarehouse && rowWarehouse !== lockWarehouse) {
      return { ...row, rowclass: "row-inactive" };
    }
    return { ...row, rowclass: "" };
  });
};

// Transit and reserve rows can be ticked too; only the row lock and adjustment hold stop a tick.
const isRowCheckboxLocked = (row) =>
  row?.rowclass === "row-inactive" || Boolean(row?.is_adjustment_held);

// Which bulk buttons a ticked row allows. Rows blocked here can still be printed.
const getRowBulkActions = (row) => {
  const notTransferable =
    row?.isnottransferable === true || row?.isnottransferable === "true";
  // In transit, or a transfer already started on an order or reserve row.
  if (row?.status_type === "transit" || notTransferable) {
    return { pos: false, reserve: false, transfer: false };
  }
  // Plain warehouse stock can only be moved out.
  if (row?.status_type === "warehouse") {
    return { pos: false, reserve: false, transfer: true };
  }
  // Two locations in the location column: still has to move to its destined location.
  if (["custom_order", "repair_order", "reserve"].includes(row?.status_type)) {
    return { pos: false, reserve: false, transfer: Boolean(row?.warehouse_location_name) };
  }
  return { pos: true, reserve: true, transfer: true };
};

const MyInventory = (props) => {
  const { t } = useTranslation();
  const dataFetched = useRef();
  const colDropdownRefItem = useRef(null);
  const colDropdownRefCollection = useRef(null);
  const colDropdownRefMetal = useRef(null);
  const colDropdownRefStone = useRef(null);
  const colDropdownRefSize = useRef(null);
  const colDropdownRefLocation = useRef(null);
  const colDropdownRefStatus = useRef(null);
  const colDropdownRefStockId = useRef(null);
  const colFilterTriggerRefs = useRef({});
  const stickyThRefs = useRef([]);
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const viewDropdownRef = useRef(null);
  const viewDropdownMenuRef = useRef(null);
  const [viewDropdownPortalStyle, setViewDropdownPortalStyle] = useState({});
  const [openColFilter, setOpenColFilter] = useState(null);
  const [colFilterPortalStyle, setColFilterPortalStyle] = useState({});
  const [stickyLefts, setStickyLefts] = useState([
    0, 40, 80, 135, 250, 340, 445,
  ]);
  const [inventorylist, setInventorylist] = useState([]);
  const [inventorycounts, setInventorycounts] = useState();
  const [exportFormat, setExportFormat] = useState("xlsx");
  const [filterdata, setFilterdata] = useState();
  const [showoption, setShowoption] = useState(false);
  const [showpos, setShowpos] = useState([]);
  const [transferlist, setTransferlist] = useState([]);
  const [locationidlist, setLocationidlist] = useState([]);
  const [showtransfer, setShowtransfer] = useState(false);
  const [filtername, setFiltername] = useState("");
  const [limit, setLimit] = useState(100);
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [SelectAllStatus, setSelectAllStatus] = useState();
  const [Selectlist, setSelectlist] = useState([]);
  const [productPrintLoading, setProductPrintLoading] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const productPrintLock = useRef(false);
  const [getoneproduct, setOneproduct] = useState();
  const [imageid, setImageid] = useState();
  const [socialurl, setSocialurl] = useState();
  const [shareloader, setShareloader] = useState(false);
  const [selectedlocation, setSelectedlocation] = useState();
  const [selectedwarehouse, setSelectedwarehouse] = useState("");
  const rowLockRef = useRef({ locationId: "", warehouseId: "", active: false });
  const selectAllActiveRef = useRef(false);
  const selectedRowCacheRef = useRef(new Map());
  const [product_id, setProduct_id] = useState();
  const [cart_id, setCart_id] = useState();
  const [getSkipNumbers, setSkipNumbers] = useState(0);
  const [datalodaer, setDatsLodaer] = useState(false);
  const [datatotal, setDatatotal] = useState({ total_qty: 0, total_price: "" });
  const [traceData, setTraceData] = useState();
  const [traceDetail, setTraceDetail] = useState({});
  const [payload, setPayload] = useState();
  const [invCount, setInvCount] = useState(0);
  const [viewMode, setViewMode] = useState("table");
  const [viewDropdownOpen, setViewDropdownOpen] = useState(false);
  const [colFilterOptions, setColFilterOptions] = useState({});
  const [syncRfidLoading, setSyncRfidLoading] = useState(false);
  const [rfidIntegrate, setRfidIntegrate] = useState();
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const traceabilityEnabled = generalsettings?.data?.generalsetup?.traceability === "1";
  const [priceExportFormat, setPriceExportFormat] = useState("xlsx");

  const clearRowSelection = () => {
    selectAllActiveRef.current = false;
    setSelectlist([]);
    setTransferlist([]);
    setLocationidlist([]);
    setSelectAllStatus(false);
    setShowoption(false);
    setShowtransfer(false);
    setShowpos([]);
    setSelectedlocation("");
    setSelectedwarehouse("");
    rowLockRef.current = { locationId: "", warehouseId: "", active: false };
    setInventorylist((prev) => applyInventoryRowLock(prev, "", ""));
  };

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
    clearRowSelection();
  };

  const getStatusDotClass = (status) => {
    const map = {
      stock: "light-blue-bg",
      transit: "green-bg",
      warehouse: "status-gray-bg",
      reserve: "yellow-bg",
      repair_order: "purple-bg",
      custom_order: "danger-bg",
    };
    return map[status] || "light-blue-bg";
  };

  const getStatusLabel = (status) => {
    const map = {
      stock: "Stock",
      transit: "Transit",
      warehouse: "Warehouse",
      reserve: "Reserve",
      repair_order: "Repair Order",
      custom_order: "Custom Order",
    };
    return map[status] || status || "";
  };
  const [activeFilters, setActiveFilters] = useState({
    item: [],
    collection: [],
    metal: [],
    stone: [],
    size: [],
    location: [],
    status: [],
    price: [],
    stock_id: [],
  });
  const [colFilterSearch, setColFilterSearch] = useState({
    item: "",
    collection: "",
    metal: "",
    stone: "",
    size: "",
    location: "",
    status: "",
    stock_id: "",
  });
  // Client-side sort from the column filter menus, on the field each cell displays.
  // Status is not sortable. The rows themselves are reordered (not a sorted copy)
  // because row actions such as handleTraceData look rows up by index.
  const colFilterSortFieldMap = {
    item: "item_code",
    collection: "collection_code",
    metal: "metal_code",
    stone: "stone_code",
    size: "size_name",
    location: "location_name",
    stock_id: "stock_id",
  };
  // A ref, not state: Getmyinventory is a useCallback that doesn't list the sort in its
  // dependencies, so it must read the current sort through a ref to re-apply it after a reload.
  const colSortConfigRef = useRef({ key: null, dir: "asc" });
  const sortInventoryRows = (rows, sortConfig) => {
    if (!sortConfig?.key || !Array.isArray(rows)) return rows;
    return [...rows].sort((a, b) => {
      const aVal = String(a?.[sortConfig.key] ?? "");
      const bVal = String(b?.[sortConfig.key] ?? "");
      return sortConfig.dir === "asc"
        ? aVal.localeCompare(bVal, undefined, { numeric: true })
        : bVal.localeCompare(aVal, undefined, { numeric: true });
    });
  };
  const handleColFilterSort = (filterKey, dir) => {
    const key = colFilterSortFieldMap[filterKey];
    if (!key) return;
    const sortConfig = { key, dir };
    colSortConfigRef.current = sortConfig;
    setInventorylist((prev) => sortInventoryRows(prev, sortConfig));
    setOpenColFilter(null);
  };
  const iconMap = {
    "652e2c3f7ab8c5b2750a4f03": { icon: chain_origin, color: "#3484D4" },
    "652e2c3f7ab8c5b2750a4f04": { icon: chainrelated, color: "#3484D4" },
    "652e2c3f7ab8c5b2750a4f05": { icon: chainrelated, color: "#3484D4" },
    "652e2c3f7ab8c5b2750a4f08": { icon: diamond_mine, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f09": { icon: diamondrelated, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f06": { icon: diamondrelated, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f07": { icon: diamondrelated, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f0a": { icon: metal_origin, color: "#73AAE1" },
    "652e2c3f7ab8c5b2750a4f0b": { icon: handcrafting, color: "#87898C" },
    "652e2c3f7ab8c5b2750a4f0c": { icon: handcrafting, color: "#87898C" },
    "652e2c3f7ab8c5b2750a4f0d": { icon: handcrafting, color: "#87898C" },
    "652e2c3f7ab8c5b2750a4f02": { icon: qc_shipping, color: "#73AB8B" },
  };

  const getTimelineData = (data) => {
    const timeline = [];

    // 1. Add product design at top
    timeline.push({
      id: "product_design",
      name: "Product Design",
      countries: [data?.product_design_trace ? data?.product_design_trace : []],
      transactionId: data?.product_design_trace_detail?.transactionId || "-",
      iconName: { icon: product_design, color: "#3C609C" },
    });

    // 2. Add traceability items sorted by iconMap order (reverse order)
    const iconMapOrder = [
      "652e2c3f7ab8c5b2750a4f03",
      "652e2c3f7ab8c5b2750a4f04",
      "652e2c3f7ab8c5b2750a4f05",
      "652e2c3f7ab8c5b2750a4f08",
      "652e2c3f7ab8c5b2750a4f09",
      "652e2c3f7ab8c5b2750a4f06",
      "652e2c3f7ab8c5b2750a4f07",
      "652e2c3f7ab8c5b2750a4f0a",
      "652e2c3f7ab8c5b2750a4f0b",
      "652e2c3f7ab8c5b2750a4f0c",
      "652e2c3f7ab8c5b2750a4f0d",
      "652e2c3f7ab8c5b2750a4f02",
    ];

    // Items in the defined order
    const orderedItems = iconMapOrder
      .filter((key) => data.traceability[key])
      .map((key) => ({
        id: key,
        ...data.traceability[key],
        iconName: iconMap[key]
          ? iconMap[key]
          : {
              icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
              color: "#606060",
            },
      }));

    // Items not in iconMapOrder (put at last)
    const unorderedItems = Object.keys(data.traceability)
      .filter((key) => !iconMapOrder.includes(key))
      .map((key) => ({
        id: key,
        ...data.traceability[key],
        iconName: iconMap[key]
          ? iconMap[key]
          : {
              icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
              color: "#606060",
            },
      }));

    timeline.push(...orderedItems, ...unorderedItems);
    return timeline;
  };

  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const getshareinventary = async () => {
    setShareloader(true);
    try {
      const postdata = {
        item: payload?.item ? payload?.item : [],
        collection: payload?.collection ? payload?.collection : [],
        metal: payload?.metal ? payload?.metal : [],
        size: payload?.size ? payload?.size : [],
        stone: payload?.stone ? payload?.stone : [],
        productStatus: payload?.status ? payload?.status : [],
        location: payload?.location ? payload?.location : [],
        price: payload?.price ? payload?.price : [],
        search: filtername,
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/inventory/print/myInventory`,
      );

      if (res.code === 200) {
        setSocialurl(res?.link);
        setShareloader(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const printSelectedProducts = async (kind) => {
    if (productPrintLock.current) return;
    // Nothing ticked, or select all on: print everything on screen.
    const printIds =
      selectAllActiveRef.current || !Selectlist.length
        ? inventorylist.map((row) => row?.id)
        : Selectlist;
    if (!printIds.length) {
      error(t("No items to print"));
      return;
    }
    setExportModalOpen(false);
    productPrintLock.current = true;
    setProductPrintLoading(true);
    const GetloadingID = loading();
    try {
      const res = await _Api(
        {
          poProduct_id: printIds,
          website_url: window.location.hostname,
        },
        kind === "catalog"
          ? `api/v1/Inventory/inventory/print/getCatalogPdf`
          : `api/v1/Inventory/inventory/print/productDetail`,
      );
      const href = res?.printURLdecode || res?.url || res?.link;
      if (res?.code === 200 && href) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.href = href;
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message ? res?.message : res?.errors,
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    } finally {
      productPrintLock.current = false;
      setProductPrintLoading(false);
    }
  };

  const getprintmyinventary = async () => {
    let GetloadingID = loading();
    try {
      const postdata = {
        item: payload?.item ? payload?.item : [],
        collection: payload?.collection ? payload?.collection : [],
        metal: payload?.metal ? payload?.metal : [],
        size: payload?.size ? payload?.size : [],
        stone: payload?.stone ? payload?.stone : [],
        productStatus: payload?.productStatus ? payload?.productStatus : [],
        location: payload?.location ? payload?.location : [],
        price: payload?.price ? payload?.price : [],
        search: filtername,
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/inventory/print/myInventory`,
      );
      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message ? res?.message : res?.errors,
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };

  const handleChange = (event) => {
    if (event.target.checked) {
      let posorderarray = [];
      const selected = [...Selectlist];
      const mainarray = [...inventorylist];
      const transferarray = [...transferlist];
      const locationarray = [...locationidlist];
      let checking = document.querySelectorAll(".inventorytablecheck");
      for (let i = 0; i < checking.length; i++) {
        if (checking[i].checked) {
          posorderarray.push(i);
          setShowoption(true);
        }
        setShowpos(posorderarray);
      }
      if (selected.filter((e) => e === event.target.id).length === 0) {
        selected.push(event.target.id);
      }
      setSelectlist(selected);
      const currentid = mainarray.filter((all) => {
        return all.id === event.target.id;
      });
      const isFirstSelection = Selectlist.length === 0;
      const lockLocation = isFirstSelection
        ? currentid[0]?.location_id
        : selectedlocation || currentid[0]?.location_id;
      const lockWarehouse = isFirstSelection
        ? currentid[0]?.warehouse_id
          ? currentid[0].warehouse_id
          : "null"
        : selectedwarehouse ||
          (currentid[0]?.warehouse_id ? currentid[0].warehouse_id : "null");
      setSelectedlocation(lockLocation);
      setSelectedwarehouse(lockWarehouse);
      rowLockRef.current = {
        locationId: lockLocation,
        warehouseId: lockWarehouse,
        active: true,
      };
      setInventorylist((prev) =>
        applyInventoryRowLock(prev, lockLocation, lockWarehouse),
      );
      if (transferarray?.length === 0) {
        setShowtransfer(true);
        locationarray.push(currentid[0]?.location_id);
        setLocationidlist(locationarray);
        transferarray.push(event.target.id);
        setTransferlist(transferarray);
      } else {
        const checkloc = locationarray.filter(
          (locid) => locid === currentid[0]?.location_id,
        );
        if (checkloc?.length) {
          transferarray.push(event.target.id);
          setShowtransfer(true);
          setTransferlist(transferarray);
        } else {
          setShowtransfer(false);
        }
      }
    } else {
      selectAllActiveRef.current = false;
      setSelectAllStatus(false);
      let posorderarray = [];
      const mainarray = [...inventorylist];
      const transferarray = [...transferlist];
      const locationarray = [...locationidlist];
      let checking = document.querySelectorAll(".inventorytablecheck");
      for (let i = 0; i < checking.length; i++) {
        if (checking[i].checked) {
          posorderarray.push(i);
          setShowoption(true);
        }
        setShowpos(posorderarray);
      }
      setSelectlist((current) =>
        current.filter((item) => item !== event.target.id),
      );
      // Rows ticked on other pages still count, so check the whole selection, not this page.
      if (!Selectlist.some((id) => id !== event.target.id)) {
        setShowoption(false);
        setSelectedlocation("");
        setSelectedwarehouse("");
        rowLockRef.current = { locationId: "", warehouseId: "", active: false };
        setInventorylist((prev) => applyInventoryRowLock(prev, "", ""));
      }

      const currentid = mainarray.filter((all) => {
        return all.id === event.target.id;
      });
      if (transferarray?.length === 1) {
        setLocationidlist((current) =>
          current.filter((item) => item !== currentid[0]?.location_id),
        );
        setTransferlist((current) =>
          current.filter((item) => item !== event.target.id),
        );
        setShowtransfer(true);
        setSelectedlocation("");
        setSelectedwarehouse("");
      } else {
        const checkloc = locationarray.filter(
          (locid) => locid === currentid[0]?.location_id,
        );
        if (checkloc?.length) {
          setTransferlist((current) =>
            current.filter((item) => item !== event.target.id),
          );
          var callcheck = document.querySelectorAll(".inventorytablecheck");
          for (var i = 0; i < callcheck.length; i++) {
            if (callcheck[i].checked) {
              let locationid = callcheck[i].getAttribute("data-locationid");
              const notmatch = locationarray.filter(
                (locid) => locid !== locationid,
              );
              if (notmatch.length) {
                setShowtransfer(false);
              } else {
                setShowtransfer(true);
              }
            }
          }
        } else {
          if (transferarray?.length) {
            setShowtransfer(true);
          } else {
            setShowtransfer(false);
          }
        }
      }
    }
  };

  const inventorycountsapi = async () => {
    try {
      const postdata = {
        location: [],
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/my/inventory-statics-optimized`,
      );
      if (res?.code === 200) {
        setInventorycounts(res?.data);
        setRfidIntegrate(res?.data?.rfidIntegration?.status || false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  // const inventorylowercount = async (filter, search, limit) => {
  //   try {
  //     const postdata = {
  //       item: filter?.item ? filter?.item : [],
  //       collection: filter?.collection ? filter?.collection : [],
  //       metal: filter?.metal ? filter?.metal : [],
  //       size: filter?.size ? filter?.size : [],
  //       stone: filter?.stone ? filter?.stone : [],
  //       productStatus: filter?.status ? filter?.status : [],
  //       location: filter?.location ? filter?.location : [],
  //       price: filter?.price ? filter?.price : [],
  //       search: search === "" ? search : filtername,
  //       limit: limit,
  //       allocated: filter?.allocated ? filter?.allocated : false,
  //       traced: filter?.traced ? filter?.traced : false,
  //     };
  //     let res = await _Api(
  //       postdata,
  //       `api/v1/Inventory/my/inventory-lowerStatics`
  //     );
  //     if (res?.code === 200) {
  //       setDatatotal(res?.data);
  //     }
  //   } catch (err) {
  //     console.log(err, "err");
  //   }
  // };
  const filterbyname = (search) => {
    clearRowSelection();
    setstate({ ...state, currentPage: 1 });
    Getmyinventory(1, limit, filterdata, search, 0);
  };
  const getlimit = (limit) => {
    clearRowSelection();
    setLimit(limit);
    Getmyinventory(1, limit, filterdata);
    setstate({ ...state, currentPage: 1 });
  };
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    clearRowSelection();
    setstate({ ...state, currentPage: current });
    Getmyinventory(current, "", filterdata);
  };

  const Getmyinventory = useCallback(
    async (current, firstlimit, filter, search, skip) => {
      let tablelimit = 1;
      if (firstlimit === "ALL") {
        tablelimit = 1;
      } else {
        tablelimit = firstlimit ? firstlimit : limit;
      }
      setDatsLodaer(true);
      var skipNumber = current ? (current - 1) * tablelimit : 0;
      setInvCount(0);
      try {
        const postdata = {
          item: filter?.item ? filter?.item : [],
          collection: filter?.collection ? filter?.collection : [],
          metal: filter?.metal ? filter?.metal : [],
          size: filter?.size ? filter?.size : [],
          stone: filter?.stone ? filter?.stone : [],
          productStatus: filter?.status ? filter?.status : [],
          location: filter?.location ? filter?.location : [],
          stock_id: filter?.stock_id ? filter?.stock_id : [],
          price: filter?.price ? filter?.price : [],
          search: search === "" ? search : filtername,
          limit: firstlimit ? firstlimit : limit,
          skip: skip === 0 ? skip : skipNumber,
          allocated: filter?.allocated ? filter?.allocated : false,
          traced: filter?.traced ? filter?.traced : false,
        };
        setPayload(postdata);
        let resPoinventory = await _Api(
          postdata,
          `api/v1/Inventory/my/listoptimized`,
        );
        if (resPoinventory?.code === 200) {
          setFilterdata(filter);
          // Rows are keyed by index, so ticks would stay on the new page's rows.
          if (selectAllActiveRef.current) {
            document
              .querySelectorAll(".inventorytablecheck")
              .forEach((check) => {
                check.checked = false;
              });
            clearRowSelection();
          }
          setSelectAllStatus(false);
          setDatsLodaer(false);
          setSkipNumbers(skip === 0 ? skip : skipNumber);
          let pageini = 1;
          if (postdata.limit === "ALL") {
            pageini = resPoinventory?.total;
          } else {
            pageini = postdata.limit;
          }
          setstate({
            ...state,
            totalPages: Math.ceil(resPoinventory?.total / pageini),
            currentPage: current ? current : 1,
          });

          setInventorylist(
            sortInventoryRows(
              applyInventoryRowLock(
                (resPoinventory?.data || []).map((row) => ({
                  ...row,
                  rowclass: "",
                })),
                rowLockRef.current.active ? rowLockRef.current.locationId : "",
                rowLockRef.current.active ? rowLockRef.current.warehouseId : "",
              ),
              colSortConfigRef.current,
            ),
          );
          setInvCount(resPoinventory?.total);
          setDatatotal({
            total_qty: resPoinventory?.total_qty ?? 0,
            total_price: resPoinventory?.total_price ?? "",
          });
          // inventorylowercount(
          //   filter,
          //   search,
          //   parseInt(postdata?.limit) + parseInt(postdata?.skip)
          // );
        }
      } catch (err) {
        console.log(err, "err");
      }
      // eslint-disable-next-line
    },
    [filtername, limit, state],
  );

  const editproduct_submit = useCallback(async () => {
    if (!getoneproduct?._id) {
      error(t("The _id field is required."));
      return;
    }

    const loadingId = loading();
    try {
      const postdata = buildInventoryProductUpdatePayload(getoneproduct);
      const res = await _Api(
        postdata,
        "api/v1/Inventory/my/update-inventory-product",
      );

      if (res?.code === 200) {
        Updateloading(
          t,
          loadingId,
          res?.message || t("Inventory product updated"),
        );
        setInventorylist((prev) =>
          prev.map((item) =>
            item._id === getoneproduct._id
              ? {
                  ...item,
                  ...getoneproduct,
                  additional_note: postdata.additional_note,
                  extra_po_information: postdata.additional_note,
                }
              : item,
          ),
        );
        clearRowSelection();
        Getmyinventory(currentPage, limit, filterdata, filtername);
        return;
      }

      if (res?.code === 400 && res?.errors) {
        Updateloading(t, loadingId, res.errors, "error");
        return;
      }

      Updateloading(
        t,
        loadingId,
        res?.message || t("Failed to update inventory product"),
        "error",
      );
    } catch (err) {
      console.log(err, "err");
      Updateloading(
        t,
        loadingId,
        err?.message || t("Something went wrong"),
        "error",
      );
    }
  }, [
    getoneproduct,
    Getmyinventory,
    currentPage,
    limit,
    filterdata,
    filtername,
    t,
  ]);

  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    inventorycountsapi();
    Getmyinventory();
    // eslint-disable-next-line
  }, [Getmyinventory]);

  // Sync all inventory data to RFID (same filters as my/list, without pagination)
  const handleSyncRfid = async () => {
    const activeFilter = filterdata || {};
    const postdata = {
      item: activeFilter?.item ? activeFilter?.item : [],
      collection: activeFilter?.collection ? activeFilter?.collection : [],
      metal: activeFilter?.metal ? activeFilter?.metal : [],
      size: activeFilter?.size ? activeFilter?.size : [],
      stone: activeFilter?.stone ? activeFilter?.stone : [],
      productStatus: activeFilter?.status ? activeFilter?.status : [],
      location: activeFilter?.location ? activeFilter?.location : [],
      price: activeFilter?.price ? activeFilter?.price : [],
      search: filtername || "",
      allocated: activeFilter?.allocated ? activeFilter?.allocated : false,
      traced: activeFilter?.traced ? activeFilter?.traced : false,
    };

    setSyncRfidLoading(true);
    let GetloadingID = loading();
    try {
      // Backend only starts the sync (products + images run in background) and replies immediately.
      // _Api never settles on network errors, so bound it with a timeout.
      const res = await Promise.race([
        _Api(postdata, `api/v1/Inventory/my/sync-rfid`),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error(t("RFID sync request timed out"))), 30000),
        ),
      ]);

      if (res?.statusCode === 200) {
        Updateloading(
          t,
          GetloadingID,
          res?.message || t("RFID sync started in background"),
        );
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message || res?.errors || res?.error || t("RFID sync failed"),
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err?.message || t("error"), "error");
    } finally {
      setSyncRfidLoading(false);
    }
  };

  const handleTraceData = (key) => {
    const mainarray = [...inventorylist];
    const item = mainarray[key];

    const tracesDetail = {
      image: item?.main_image || "",
      name: item?.name || "",
      SKU: item?.SKU || "",
      pos_Qty: item?.po_QTY || 1,
      stock_id: item?.stock_id || "-",
      transactionId: item?.product_design_trace_detail?.transactionId,
    };
    setTraceDetail(tracesDetail);

    // safely extract traceability data
    const traceability = item?.traceability || {};
    const product_design_trace = item?.product_design_trace || {
      label: "Unknown",
      value: "",
    };
    const product_design_trace_detail = item?.product_design_trace_detail || {
      transactionId: "-",
    };

    const tracesData = {
      traceability,
      product_design_trace,
      product_design_trace_detail,
    };

    const arrtrace = getTimelineData(tracesData);
    setTraceData(arrtrace);
  };

  const canSelectAll = canSelectFreeStockRows(inventorylist);
  const canPrint =
    (Selectlist.length > 0 || inventorylist.length > 0) && !productPrintLoading;

  // Ticked rows can be on another page, so keep their data once seen.
  const selectedRowActions = Selectlist.map((id) => {
    const row = inventorylist.find((item) => item?.id === id);
    if (row) selectedRowCacheRef.current.set(id, row);
    return selectedRowCacheRef.current.get(id);
  })
    .filter(Boolean)
    .map(getRowBulkActions);
  // A bulk button stays on only if every ticked row allows it.
  const selectionAllows = (action) =>
    selectedRowActions.length > 0 &&
    selectedRowActions.every((actions) => actions[action]);

  const handleSelectAll = (checked) => {
    const rowChecks = document.querySelectorAll(".inventorytablecheck");
    const pageIds = inventorylist.map((row) => row?.id);
    selectAllActiveRef.current = checked;
    setSelectAllStatus(checked);
    if (checked) {
      const freeRows = inventorylist.filter(isFreeStockRow);
      const freeIds = freeRows.map((row) => row?.id);
      const tickedIndexes = [];
      rowChecks.forEach((check, index) => {
        if (freeIds.includes(check.getAttribute("data-id"))) check.checked = true;
        if (check.checked) tickedIndexes.push(index);
      });
      const locationId = freeRows[0]?.location_id;
      const warehouseId =
        freeRows.find((row) => row?.warehouse_id)?.warehouse_id || "null";
      setSelectlist((current) => [...new Set([...current, ...freeIds])]);
      setTransferlist((current) => [...new Set([...current, ...freeIds])]);
      setLocationidlist([locationId]);
      setSelectedlocation(locationId);
      setSelectedwarehouse(warehouseId);
      setShowoption(true);
      setShowtransfer(true);
      setShowpos(tickedIndexes);
      rowLockRef.current = { locationId, warehouseId, active: true };
      setInventorylist((prev) =>
        applyInventoryRowLock(prev, locationId, warehouseId),
      );
      return;
    }
    rowChecks.forEach((check) => {
      check.checked = false;
    });
    const remaining = Selectlist.filter((id) => !pageIds.includes(id));
    if (!remaining.length) {
      clearRowSelection();
      return;
    }
    setSelectlist(remaining);
    setTransferlist((current) =>
      current.filter((id) => !pageIds.includes(id)),
    );
    setShowpos([]);
  };

  useEffect(() => {
    getColFilterOptions();
  }, []);

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".my-inventory-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--inventory-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncInventoryTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    if (viewMode !== "table") return undefined;

    let frame = 0;
    const syncInventoryTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const footRow = bodyTable.querySelector("tfoot tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          const fw = footRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, fw, 40)));
        }
        const total = widths.reduce((sum, w) => sum + w, 0);
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }

        let acc = 0;
        const lefts = stickyThRefs.current.map((th) => {
          const left = acc;
          if (th) acc += th.offsetWidth;
          return left;
        });
        setStickyLefts((prev) => {
          if (
            prev.length === lefts.length &&
            prev.every((value, index) => value === lefts[index])
          ) {
            return prev;
          }
          return lefts;
        });
      });
    };

    syncInventoryTableWidths();
    window.addEventListener("resize", syncInventoryTableWidths);
    const observer = new ResizeObserver(syncInventoryTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncInventoryTableWidths);
      observer.disconnect();
    };
  }, [viewMode, inventorylist, datalodaer]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        viewDropdownRef.current &&
        !viewDropdownRef.current.contains(e.target) &&
        !viewDropdownMenuRef.current?.contains(e.target)
      ) {
        setViewDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const updateViewDropdownPosition = useCallback(() => {
    const trigger = viewDropdownRef.current;
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    setViewDropdownPortalStyle({
      position: "fixed",
      top: rect.bottom + 4,
      right: Math.max(8, window.innerWidth - rect.right),
      background: "#fff",
      border: "1px solid #E5E5E5",
      borderRadius: "6px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      padding: "6px",
      display: "flex",
      gap: "4px",
      zIndex: 4000,
    });
  }, []);

  useEffect(() => {
    if (!viewDropdownOpen) return undefined;
    updateViewDropdownPosition();
    window.addEventListener("resize", updateViewDropdownPosition);
    window.addEventListener("scroll", updateViewDropdownPosition, true);
    return () => {
      window.removeEventListener("resize", updateViewDropdownPosition);
      window.removeEventListener("scroll", updateViewDropdownPosition, true);
    };
  }, [viewDropdownOpen, updateViewDropdownPosition]);

  const getColFilterOptions = async () => {
    try {
      let res = await _Api(
        { custom_filter_enable: true },
        `api/v1/Inventory/my/filter`,
      );
      if (res?.code === 200) {
        setColFilterOptions(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const hendleColDropdownHide = () => {
    setOpenColFilter(null);
  };

  const getColFilterMenuRef = (filterKey) => {
    const refMap = {
      item: colDropdownRefItem,
      collection: colDropdownRefCollection,
      metal: colDropdownRefMetal,
      stone: colDropdownRefStone,
      size: colDropdownRefSize,
      location: colDropdownRefLocation,
      status: colDropdownRefStatus,
      stock_id: colDropdownRefStockId,
    };
    return refMap[filterKey];
  };

  const updateColFilterPortalPosition = (filterKey) => {
    const trigger = colFilterTriggerRefs.current[filterKey];
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    const menuWidth = 286;
    let left = rect.left;
    if (left + menuWidth + 8 > viewportWidth) {
      left = Math.max(8, viewportWidth - menuWidth - 8);
    }
    setColFilterPortalStyle({
      position: "fixed",
      top: rect.bottom + 6,
      left,
      width: menuWidth,
      zIndex: 3000,
    });
  };

  useEffect(() => {
    if (!openColFilter) return undefined;
    updateColFilterPortalPosition(openColFilter);
    const handleReposition = () => updateColFilterPortalPosition(openColFilter);
    const handleOutsideClick = (event) => {
      const trigger = colFilterTriggerRefs.current[openColFilter];
      const menu = getColFilterMenuRef(openColFilter)?.current;
      if (trigger?.contains(event.target) || menu?.contains(event.target)) {
        return;
      }
      setOpenColFilter(null);
    };
    window.addEventListener("resize", handleReposition);
    window.addEventListener("scroll", handleReposition, true);
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      window.removeEventListener("resize", handleReposition);
      window.removeEventListener("scroll", handleReposition, true);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openColFilter]);

  const handleColFilterItemChange = (event, value, filterKey) => {
    setActiveFilters((prev) => ({
      ...prev,
      [filterKey]: event.target.checked
        ? [...prev[filterKey], value]
        : prev[filterKey].filter((v) => v !== value),
    }));
  };

  const handleColFilterSelectAll = (event, filterKey) => {
    const isStatus = filterKey === "status";
    const allValues = (colFilterOptions?.[filterKey] || []).map((o) =>
      isStatus ? o.value : o._id,
    );
    setActiveFilters((prev) => ({
      ...prev,
      [filterKey]: event.target.checked ? allValues : [],
    }));
  };

  const applyColFilter = (filterKey) => {
    clearRowSelection();
    Getmyinventory(1, limit, activeFilters, filtername, 0);
    hendleColDropdownHide();
  };

  const handleClearAllFilters = () => {
    const empty = {
      item: [],
      collection: [],
      metal: [],
      stone: [],
      size: [],
      location: [],
      status: [],
      price: [],
      stock_id: [],
    };
    setActiveFilters(empty);
    setColFilterSearch({
      item: "",
      collection: "",
      metal: "",
      stone: "",
      size: "",
      location: "",
      status: "",
      stock_id: "",
    });
    clearRowSelection();
    Getmyinventory(1, limit, empty, filtername, 0);
  };

  const renderColFilterDropdown = (filterKey, dropdownRef) => {
    const isStatus = filterKey === "status";
    const options = colFilterOptions?.[filterKey] || [];
    const checkedVals = activeFilters[filterKey] || [];
    const searchTerm = colFilterSearch[filterKey] || "";
    const filteredOptions = searchTerm
      ? options.filter((o) =>
          o?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
        )
      : options;
    const isOpen = openColFilter === filterKey;

    const menuContent = (
      <div
        className="dropdown-menu show com-custom-table-tag-filter-menu dtbs-filter-dropdown-menu dtbs-filter-portal-menu p-0 border-0 overflow-hidden"
        style={colFilterPortalStyle}
        ref={dropdownRef}
        onClick={(e) => e.stopPropagation()}
      >
        {!isStatus && (
          <div className="asc-des-order">
            <div
              className="asc-des-order-single cursor-pointer"
              onClick={() => handleColFilterSort(filterKey, "asc")}
            >
              <img src={base_assets + "images/icons/arrow-sort-up.png"} alt="" />
              {t("Sort Ascending")}
            </div>
            <div
              className="asc-des-order-single cursor-pointer"
              onClick={() => handleColFilterSort(filterKey, "desc")}
            >
              <img src={base_assets + "images/icons/arrow-sort-down.png"} alt="" />
              {t("Sort Descending")}
            </div>
          </div>
        )}
        {!isStatus && (
          <div className="com-custom-table-tag-filter-menu-search">
            <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
              <img
                src={base_assets + "images/icons/search-icon.png"}
                alt=""
              />
              <input
                className="border-0"
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) =>
                  setColFilterSearch((prev) => ({
                    ...prev,
                    [filterKey]: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        )}
        <div className="com-custom-table-tag-filter-menu-select">
          <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
            <div>
              <input
                className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                type="checkbox"
                id={`colfilter-all-${filterKey}`}
                onChange={(e) => handleColFilterSelectAll(e, filterKey)}
                checked={
                  options.length > 0 && checkedVals.length === options.length
                }
              />
              <label
                className="form-check-label cursor-pointer fw-semibold"
                htmlFor={`colfilter-all-${filterKey}`}
              >
                {t("Select All")}
              </label>
            </div>
            <label>
              {checkedVals.length}/{options.length} {t("Selected")}
            </label>
          </div>
          <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
            {filteredOptions.map((opt, idx) => {
              const val = isStatus ? opt.value : opt._id;
              const optId = `colfilter-${filterKey}-${idx}`;
              return (
                <li
                  className="com-custom-table-tag-filter-menu-select-list-single"
                  key={optId}
                >
                  <input
                    className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                    type="checkbox"
                    id={optId}
                    checked={checkedVals.includes(val)}
                    onChange={(e) =>
                      handleColFilterItemChange(e, val, filterKey)
                    }
                  />
                  <label
                    className="form-check-label cursor-pointer"
                    htmlFor={optId}
                  >
                    {opt?.name}
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
          <button
            className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
            onClick={() => {
              setActiveFilters((prev) => ({ ...prev, [filterKey]: [] }));
              setColFilterSearch((prev) => ({ ...prev, [filterKey]: "" }));
            }}
          >
            {t("Clear")}
          </button>
          <button
            className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold"
            onClick={() => applyColFilter(filterKey)}
          >
            {t("Apply")}
          </button>
        </div>
      </div>
    );

    return (
      <div
        className="d-inline-block com-custom-table-tag-filter dtbs-filter-dropdown"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          ref={(el) => {
            colFilterTriggerRefs.current[filterKey] = el;
          }}
          className="after-none bg-transparent border-0 p-0"
          type="button"
          aria-expanded={isOpen}
          onClick={() => {
            setOpenColFilter((prev) => {
              const next = prev === filterKey ? null : filterKey;
              if (next) {
                const trigger = colFilterTriggerRefs.current[filterKey];
                if (trigger) {
                  const rect = trigger.getBoundingClientRect();
                  const viewportWidth =
                    window.innerWidth || document.documentElement.clientWidth;
                  const menuWidth = 286;
                  let left = rect.left;
                  if (left + menuWidth + 8 > viewportWidth) {
                    left = Math.max(8, viewportWidth - menuWidth - 8);
                  }
                  setColFilterPortalStyle({
                    position: "fixed",
                    top: rect.bottom + 6,
                    left,
                    width: menuWidth,
                    zIndex: 3000,
                  });
                }
              }
              return next;
            });
          }}
        >
          <img
            className="ms-2 com-custom-table-tag-filter-img"
            src={base_assets + "images/icons/table-filter-icon.png"}
            alt=""
          />
        </button>
        {isOpen && createPortal(menuContent, document.body)}
      </div>
    );
  };

  const downloadexclsheet = async () => {
    let GetloadingID = loading();
    try {
      let postdata = {
        item: payload?.item ? payload?.item : [],
        collection: payload?.collection ? payload?.collection : [],
        metal: payload?.metal ? payload?.metal : [],
        size: payload?.size ? payload?.size : [],
        stone: payload?.stone ? payload?.stone : [],
        productStatus: payload?.productStatus ? payload?.productStatus : [],
        location: payload?.location ? payload?.location : [],
        price: payload?.price ? payload?.price : [],
        search: filtername,
        format: exportFormat || "xlsx",
      };
      let res = await _Api(postdata, `api/v1/Inventory/my/inventoryExport`);
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, res?.message);
      } else {
        Updateloading(t, GetloadingID, res?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  // const downloadexclpricesheet = async () => {
  const downloadexclpricesheet = async (withStockId = false) => {
    let GetloadingID = loading();
    try {
      // let postdata = {};
      // let postdata = { with_stock_id: withStockId };
      let postdata = {
        with_stock_id: withStockId,
        search: filtername || "",
        item: payload?.item || [],
        collection: payload?.collection || [],
        metal: payload?.metal || [],
        stone: payload?.stone || [],
        size: payload?.size || [],
        location: payload?.location || [],
        ids: Selectlist || [],
        format: priceExportFormat || "xlsx",
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/my/inventoryPriceExport`,
      );
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, res?.message);
      } else {
        Updateloading(t, GetloadingID, res?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const deallcocation = async (event) => {
    let GetloadingID = loading();
    try {
      const postdata = {
        po_product_id: product_id,
        customOrderId: cart_id,
        type: event,
      };
      let res = await _Api(postdata, `api/v1/Inventory/po/deallocation`);
      if (res.code === 200) {
        Updateloading(t, GetloadingID, t("Deallocation success!!"));
        clearRowSelection();
        Getmyinventory();
      } else {
        Updateloading(t, GetloadingID, t("somthing went wrong"), "error");
        clearRowSelection();
        Getmyinventory();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getSelectedDataList = (selectedList, DataList, dataField = "") => {
    let data = [];
    if (selectedList.length > 0) {
      selectedList.map(function (v) {
        console.log(v);
        const filteredDataList = DataList.filter((l, idx) => l.id === v);
        if (filteredDataList.length > 0) {
          if (dataField !== "") {
            data.push(filteredDataList[0][dataField]);
          } else {
            data.push(filteredDataList[0]);
          }
        }
        return true;
      });
    } else {
      return [];
    }

    return data;
  };
  const handleChangefortrace = (obj) => {
    clearRowSelection();
    Getmyinventory(1, limit, obj, "");
  };

  const handleClear = (e, obj) => {
    e.stopPropagation();
    clearRowSelection();
    Getmyinventory(1, limit, obj, "");
  };
  const cardTotalAmount = inventorycounts?.total_Amount;
  const cardTotalLineCount = getStackedPriceLineCount(cardTotalAmount, 3);
  return (
    <React.Fragment>
      <div className="main-body my-inventory-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-inventory-page" ref={stickyTopRef}>
              <h1 className="main-body-heading">{t("My Inventory")}</h1>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  <div className="main-body-top-inventory-status-card-1">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/free-stock.png"}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Free Stock")}</p>
                      <h2 className="inventory-value stock">
                        {inventorycounts?.QTY}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card-1">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/sku.png"}
                        className="inventory-img"
                        alt="sku"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("SKU")}</p>
                      <h2 className="inventory-value sku">
                        {inventorycounts?.SKU}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card-1">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/value.png"}
                        className="inventory-img"
                        alt="value"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Total Value")}</p>
                      <h2
                        className={`inventory-value value tooltip-area-up ${getStatusValueFontClass(
                          cardTotalLineCount,
                        )}`.trim()}
                      >
                        {renderStackedTotalPrice(cardTotalAmount, 3)}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card-1">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/location.png"}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Locations")}</p>
                      <h2 className="inventory-value location">
                        {inventorycounts?.location}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main-body-top-status-bar">
                <Select
                  className="limit-select short mx-3"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getlimit(e.value);
                  }}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
                {/* <button
                  data-bs-toggle="modal"
                  data-bs-target="#TraceabilityModal"
                  onClick={() => {
                    handleTraceData(1);
                  }}
                >
                  Trace
                </button> */}
                <div className="main-body-top-status-bar-filter">
                  <button
                    className="main-body-top-status-bar-filter-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#filterinventory"
                  >
                    <img
                      className="d-block"
                      src={base_assets + "/images/icons/search-outline.png"}
                      alt=""
                    />
                  </button>
                  <input
                    type="text"
                    value={filtername}
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t("SKU/StockID")}
                    onKeyPress={(e) =>
                      e.key === "Enter" && filterbyname(e.target.value)
                    }
                    onChange={(e) => {
                      setFiltername(e.target.value);
                    }}
                  />
                  {filtername ? (
                    <img
                      className="main-body-top-status-bar-filter-clear"
                      src={base_assets + "images/icons/False.png"}
                      onClick={(e) => {
                        setFiltername("");
                        filterbyname("");
                      }}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  <button
                    onClick={filterbyname}
                    className="main-body-top-status-bar-filter-search"
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker">
                  <button className="print-export-dropdown-selected-icon d-none">
                    <img
                      src={base_assets + "images/icons/printer-icon.png"}
                      alt=""
                    />
                  </button>
                  {/* <span className="status-inventory-stock-btn" data-bs-toggle="modal" data-bs-target="#barcodeModal" >
                    <i className="fa fa-barcode"></i>
                  </span>  */}
                  <div className="status-inventory">
                    <div className="status-inventory-stock">
                      <span
                        className="tooltip-area-up"
                        style={{
                          display: "inline-flex",
                          cursor: canPrint ? "pointer" : "not-allowed",
                        }}
                      >
                        <button
                          type="button"
                          className="inventory-product-print"
                          onClick={() => {
                            if (!canPrint) return;
                            setExportModalOpen(true);
                          }}
                          disabled={!canPrint}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            width: 24,
                            height: 24,
                            lineHeight: 1,
                            color: canPrint ? "#5CC7C1" : "#c5c5c5",
                            cursor: "inherit",
                            pointerEvents: canPrint ? "auto" : "none",
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M12 16V4M12 4L7.5 8.5M12 4L16.5 8.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 15.5V18.5C4 19.6 4.9 20.5 6 20.5H18C19.1 20.5 20 19.6 20 18.5V15.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                        <span className="tooltip-area-up-text">{t("Print")}</span>
                      </span>
                      <div className="tracefilter-container">
                        <input
                          className="tracefilter-checkbox d-none"
                          type="checkbox"
                          id="allocated-checkbox"
                          checked={payload?.allocated}
                        />

                        <label
                          htmlFor="allocated-checkbox"
                          className={`tracefilter-label tooltip-area-up ${
                            payload?.allocated ? "checked" : ""
                          }`}
                        >
                          <img
                            className="img"
                            src={allocatableimg}
                            onClick={() =>
                              handleChangefortrace({ allocated: true })
                            }
                            alt="Link icon"
                          />
                          {payload?.allocated ? (
                            <span className="tracefilter-number">
                              {invCount || 0}
                            </span>
                          ) : (
                            ""
                          )}

                          {payload?.allocated && (
                            <button
                              className="tracefilter-clearbtn"
                              onClick={(e) =>
                                handleClear(e, { allocated: false })
                              }
                              title="Clear Filter"
                            >
                              x
                            </button>
                          )}
                          <span className="tooltip-area-up-text">
                            Allocated
                          </span>
                        </label>
                      </div>
                      {generalsettings?.data?.generalsetup?.traceability ===
                      "1" ? (
                        <div className="tracefilter-container">
                          <input
                            type="checkbox"
                            id="tracefilter-checkbox"
                            checked={payload?.traced}
                            className="tracefilter-checkbox d-none"
                          />

                          <label
                            htmlFor="tracefilter-checkbox"
                            className={`tracefilter-label tooltip-area-up ${
                              payload?.traced ? "checked" : ""
                            }`}
                          >
                            <img
                              src={traceimg}
                              alt="Trace"
                              className="tracefilter-icon"
                              onClick={() =>
                                handleChangefortrace({ traced: true })
                              }
                            />
                            {payload?.traced ? (
                              <span className="tracefilter-number">
                                {invCount || 0}
                              </span>
                            ) : (
                              ""
                            )}

                            {payload?.traced && (
                              <button
                                className="tracefilter-clearbtn"
                                onClick={(e) =>
                                  handleClear(e, { traced: false })
                                }
                                title="Clear Filter"
                              >
                                x
                              </button>
                            )}
                            <span className="tooltip-area-up-text">
                              Traceability
                            </span>
                          </label>
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        ref={viewDropdownRef}
                        style={{ position: "relative" }}
                      >
                        <button
                          type="button"
                          className="tooltip-area-up"
                          onClick={() => {
                            if (!viewDropdownOpen) {
                              updateViewDropdownPosition();
                            }
                            setViewDropdownOpen((o) => !o);
                          }}
                          style={{
                            background: "transparent",
                            cursor: "pointer",
                            lineHeight: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {viewMode === "grid5" && (
                            <img src={grid5img} alt="5 columns" />
                          )}
                          {viewMode === "grid4" && (
                            <img src={grid4img} alt="4 columns" />
                          )}
                          {viewMode === "table" && (
                            <img src={tablerowimg} alt="table" />
                          )}
                          {viewDropdownOpen ? null : (
                            <span className="tooltip-area-up-text">
                              {viewMode === "grid5"
                                ? t("5 columns")
                                : viewMode === "grid4"
                                  ? t("4 columns")
                                  : t("Table view")}
                            </span>
                          )}
                        </button>
                        {viewDropdownOpen &&
                          createPortal(
                          <div
                            ref={viewDropdownMenuRef}
                            style={viewDropdownPortalStyle}
                          >
                            <button
                              type="button"
                              className="tooltip-area-up"
                              onClick={() => {
                                handleViewModeChange("grid5");
                                setViewDropdownOpen(false);
                              }}
                              style={{
                                padding: "6px 8px",
                                border: "none",
                                borderRadius: "4px",
                                background:
                                  viewMode === "grid5"
                                    ? "#5cc7c1"
                                    : "transparent",
                                cursor: "pointer",
                                lineHeight: 1,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img src={grid5img} alt="5 columns" />
                              <span className="tooltip-area-up-text">{t("5 columns")}</span>
                            </button>
                            <button
                              type="button"
                              className="tooltip-area-up"
                              onClick={() => {
                                handleViewModeChange("grid4");
                                setViewDropdownOpen(false);
                              }}
                              style={{
                                padding: "6px 8px",
                                border: "none",
                                borderRadius: "4px",
                                background:
                                  viewMode === "grid4"
                                    ? "#5cc7c1"
                                    : "transparent",
                                cursor: "pointer",
                                lineHeight: 1,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img src={grid4img} alt="4 columns" />
                              <span className="tooltip-area-up-text">{t("4 columns")}</span>
                            </button>
                            <button
                              type="button"
                              className="tooltip-area-up"
                              onClick={() => {
                                handleViewModeChange("table");
                                setViewDropdownOpen(false);
                              }}
                              style={{
                                padding: "6px 8px",
                                border: "none",
                                borderRadius: "4px",
                                background:
                                  viewMode === "table"
                                    ? "#5cc7c1"
                                    : "transparent",
                                cursor: "pointer",
                                lineHeight: 1,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img src={tablerowimg} alt="table" />
                              <span className="tooltip-area-up-text">{t("Table view")}</span>
                            </button>
                          </div>,
                          document.body
                        )}
                      </div>

                      {rfidIntegrate && (
                        <Link
                          // type="button"
                          // className="status-inventory-stock-btn"
                          className="tooltip-area-up"
                          onClick={() => {
                            !syncRfidLoading && handleSyncRfid();
                          }}
                          disabled={syncRfidLoading}
                          style={{
                            opacity: syncRfidLoading ? 0.7 : 1,
                            cursor: syncRfidLoading ? "not-allowed" : "pointer",
                          }}
                        >
                          {syncRfidLoading ? <RFIDIcon /> : <RFIDIcon />}
                          <span
                            className="tooltip-area-up-text"
                            style={{
                              textWrapMode: "wrap",
                              fontSize: "12px",
                              width: "250px",
                              whiteSpace: "normal",
                            }}
                          >
                            RFID
                            <br />
                            <span style={{ fontSize: "11px" }}>
                              {
                                "Apply filters to select the products you want to sync, then click Sync. If no filters are applied, all inventory products will be synced."
                              }
                            </span>
                          </span>
                          {/* {syncRfidLoading ? t("Syncing...") : t("Sync RFID")} */}
                        </Link>
                      )}
                      <Link
                        to="/app/inventory/quickview"
                        className="tooltip-area-up"
                        state={{
                          SKU: getSelectedDataList(
                            Selectlist,
                            inventorylist,
                            "SKU",
                          ),
                        }}
                      >
                        <img
                          style={{ width: "26px", height: "22px" }}
                          src={quickviewinvsvg}
                          alt=""
                        />
                        <span className="tooltip-area-up-text">Quick View</span>
                      </Link>

                      <Link
                        className={
                          !selectionAllows("pos") || !showoption
                            ? "noshow-inventory-status status-inventory-stock-btn"
                            : showpos.length === 1
                              ? "show-inventory-status status-inventory-stock-btn"
                              : "status-inventory-stock-btn noshow-inventory-status"
                        }
                        to="/app/inventory/posorder"
                        state={{ selectedid: Selectlist }}
                      >
                        <img
                          src={
                            base_assets +
                            "images/icons/danger-calender-icon.png"
                          }
                          alt=""
                        />
                        {t("POS Order")}
                      </Link>
                      <Link
                        to="/app/inventory/createreserves"
                        state={{ datalist: Selectlist }}
                        className={
                          parmissiondatashow?.reserve_list?.Add
                            ? (showoption || Selectlist?.length) &&
                              selectionAllows("reserve")
                              ? "show-inventory-status status-inventory-stock-btn"
                              : "noshow-inventory-status status-inventory-stock-btn"
                            : "d-none"
                        }
                      >
                        <img
                          src={
                            base_assets +
                            "images/icons/yellow-calender-icon.png"
                          }
                          alt=""
                        />
                        {t("Reserve")}
                      </Link>
                      <Link
                        to="/app/inventory/createTransfer"
                        state={{
                          createlist: transferlist,
                          hidelocationid: selectedlocation,
                          showwarehouseid: selectedwarehouse,
                          myinventory: true,
                        }}
                        className={
                          transferlist?.length && selectionAllows("transfer")
                            ? showtransfer
                              ? "status-inventory-stock-btn"
                              : "noshow-inventory-status status-inventory-stock-btn"
                            : "noshow-inventory-status status-inventory-stock-btn"
                        }
                      >
                        <img
                          src={base_assets + "images/icons/stock-fast.png"}
                          alt=""
                        />
                        {t("Transfer")}
                      </Link>
                    </div>
                  </div>
                  <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={base_assets + "images/icons/ellipsis-circular.png"}
                        alt=""
                      />
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className={
                          parmissiondatashow?.my_inventory?.Print
                            ? "dropdown-item print-dropdown-item"
                            : "d-none"
                        }
                        onClick={(e) => {
                          getprintmyinventary(e.target.value);
                        }}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/printer-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("print")}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        // onClick={(e) => {
                        //   downloadexclsheet();
                        // }}
                        data-bs-toggle="modal"
                        data-bs-target="#inventoryExportFormatModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/export-x-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("export")}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#socialModal"
                        onClick={() => getshareinventary()}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/share-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("share")}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#columnModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/column-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("column")}</span>
                      </li>
                      {/* <li
                        className="dropdown-item"
                        onClick={(e) => {
                          downloadexclpricesheet();
                        }}
                      > */}
                      <li
                        className="dropdown-item tooltip-area-up"
                        // {...(Selectlist?.length
                        //   ? {
                        //       "data-bs-toggle": "modal",
                        //       "data-bs-target": "#priceExportStockModal",
                        //     }
                        //   : { onClick: () => downloadexclpricesheet(false) })}
                          data-bs-toggle="modal"
                        data-bs-target="#priceExportStockModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/export-x-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("Price Export")}</span>
                        <span
                          className="tooltip-area-up-text price-export-tooltip-down"
                          style={{
                            textWrapMode: "wrap",
                            fontSize: "12px",
                            width: "250px",
                            whiteSpace: "normal",
                            zIndex: 1050,
                          }}
                        >
                          {t("Price Export")}
                          <br />
                          <span style={{ fontSize: "11px" }}>
                            {t(
                              "Select checkboxes to export those inventory items. If no checkbox is selected, all inventory will be exported.",
                            )}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative"
                style={{
                  maxWidth: "100%",
                  // parent is a flex row; without this the grid shrinks to its content
                  // and a 1–2 item result (e.g. Allocatable filter) collapses the cards
                  width: "100%",
                  overflow: "visible",
                }}
              >
                {viewMode !== "table" && (
                  <div
                    className={`row g-3 ${viewMode === "grid5" ? "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5" : "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4"}`}
                  >
                    {!datalodaer && inventorylist?.length
                      ? inventorylist.map((result, key) => (
                          <div className="col" key={result?.id || key}>
                            <div
                              className={
                                result?.rowclass === "row-inactive"
                                  ? "row-inactive"
                                  : ""
                              }
                              style={{
                                position: "relative",
                                zIndex: 0,
                                background: "#FFFFFF",
                                boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
                                borderRadius: "4px",
                              }}
                            >
                              {/* Image area — taller than previous 307:200 for grid cards */}
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  paddingBottom: "78%",
                                  background: "#D9D9D9",
                                  overflow: "hidden",
                                  borderRadius: "4px 4px 0 0",
                                }}
                              >
                                <img
                                  src={
                                    result?.main_image ||
                                    base_assets +
                                      "images/icon/camera_profile.png"
                                  }
                                  alt=""
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    width: "100%",
                                    height: "100%",
                                    cursor: "pointer",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                  }}
                                  onClick={() => setImageid(result?.product_id)}
                                  data-bs-toggle="modal"
                                  data-bs-target="#ProductViewModal"
                                />
                              </div>
                              {/* Checkbox — top-left. Rendered as a sibling of the
                              (overflow:hidden) image wrapper, not inside it,
                              so the "Under Adjustment" tooltip isn't clipped. */}
                              <HeldCheckbox
                                result={result}
                                wrapperStyle={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "13px",
                                  zIndex: 2,
                                }}
                                disabled={isRowCheckboxLocked(result)}
                                checked={Selectlist.includes(result?.id)}
                                wrapperClassName={
                                  isRowCheckboxLocked(result)
                                    ? "com-check checkbox-disabled"
                                    : "com-check"
                                }
                                inputClassName="inventorytablecheck gisClassTh"
                                onChange={(e) => handleChange(e)}
                                t={t}
                              />
                              {/* Top-right icon group — outside image div so tooltip is not clipped */}
                              <div
                                style={{
                                  position: "absolute",
                                  right: "16px",
                                  top: "13px",
                                  zIndex: 3,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "2px",
                                }}
                              >
                                {traceabilityEnabled && result?.traceability_on && (
                                  <img
                                    src={traceimg}
                                    alt="trace"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      cursor: "pointer",
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#TraceabilityModal"
                                    onClick={() => handleTraceData(key)}
                                  />
                                )}
                                {result?.pos_Qty !== 0 &&
                                result?.pos?.order_type === "repair_order" ? (
                                  <div
                                    className="tooltip-area-up"
                                    style={{ lineHeight: 0 }}
                                  >
                                    <img
                                      src={
                                        base_assets +
                                        "images/icons/user-purple.png"
                                      }
                                      alt="repair order"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                    <span className="tooltip-area-up-text">
                                      {result?.customer_name}
                                      {result?.customer_name ? <br /> : ""}
                                      {result?.POS_Order}
                                      {result?.POS_Order ? <br /> : ""}
                                      {result?.delivery_date}
                                    </span>
                                  </div>
                                ) : result?.pos_Qty !== 0 ? (
                                  <div
                                    className="tooltip-area-up"
                                    style={{ lineHeight: 0 }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#allocation-listedModal"
                                  >
                                    <img
                                      src={
                                        base_assets +
                                        "images/icons/user-red.png"
                                      }
                                      alt="custom order"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                    <span className="tooltip-area-up-text">
                                      {result?.customer_name}
                                      {result?.customer_name ? <br /> : ""}
                                      {result?.POS_Order}
                                      {result?.POS_Order ? <br /> : ""}
                                      {result?.delivery_date}
                                    </span>
                                  </div>
                                ) : null}
                                {result?.allocatable && (
                                  <img
                                    src={allocatableimg}
                                    alt=""
                                    style={{ width: "32px", height: "32px" }}
                                  />
                                )}
                              </div>
                              {/* Info section */}
                              <div
                                style={{
                                  padding: "14px 16px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  minHeight: "107.78px",
                                }}
                              >
                                <div>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontFamily: "Segoe UI, sans-serif",
                                      fontSize: "16px",
                                      lineHeight: "21px",
                                      color: "#A4A4A4",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => setOneproduct(result)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ProductInfoModal"
                                  >
                                    {result?.name || result?.item_name || ""}
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      marginTop: "4px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: 0,
                                        fontFamily: "Segoe UI, sans-serif",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        lineHeight: "19px",
                                        color: "#2A2A2A",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        flexShrink: 0,
                                        maxWidth: "50%",
                                      }}
                                    >
                                      {result?.SKU || ""}
                                    </p>
                                    {result?.stock_id && (
                                      <>
                                        <span
                                          style={{
                                            color: "#E5E5E5",
                                            flexShrink: 0,
                                          }}
                                        >
                                          |
                                        </span>
                                        <p
                                          style={{
                                            margin: 0,
                                            fontFamily: "Segoe UI, sans-serif",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            lineHeight: "19px",
                                            color: "#2A2A2A",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {result?.stock_id}
                                        </p>
                                      </>
                                    )}
                                    {result?.location_name && (
                                      <>
                                        <span
                                          style={{
                                            color: "#E5E5E5",
                                            flexShrink: 0,
                                          }}
                                        >
                                          |
                                        </span>
                                        <p
                                          style={{
                                            margin: 0,
                                            fontFamily: "Segoe UI, sans-serif",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            lineHeight: "19px",
                                            color: "#2A2A2A",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {result?.location_name}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "10px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Segoe UI, sans-serif",
                                      fontWeight: 400,
                                      fontSize: "18px",
                                      lineHeight: "24px",
                                      color: "#2A2A2A",
                                    }}
                                  >
                                    {result?.price || ""}
                                  </span>
                                  <div
                                    className={`status-dot ${getStatusDotClass(result?.status_type)} tooltip-area-up ms-2`}
                                    style={{
                                      width: "13px",
                                      height: "13px",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <span className="tooltip-area-up-text">
                                      {t(getStatusLabel(result?.status_type))}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                  </div>
                )}
                {viewMode === "table" && (
                  <>
                  <div className="my-inventory-sticky-thead">
                    <div
                      className="my-inventory-table-hscroll my-inventory-table-hscroll--head"
                      ref={tableHeadScrollRef}
                      onScroll={() => syncInventoryTableScroll("head")}
                    >
                      <table
                        ref={tableHeadTableRef}
                        className="stripe row-border order-column common-table table-striped main-table my-inventory-head-table"
                      >
                    <thead>
                      <tr>
                        <th
                          ref={(el) => (stickyThRefs.current[0] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[0],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          <div
                            className={
                              canSelectAll
                                ? "com-check"
                                : "com-check checkbox-disabled"
                            }
                            title={
                              canSelectAll
                                ? ""
                                : t("Select all needs rows from one location")
                            }
                          >
                            <input
                              checked={Boolean(SelectAllStatus)}
                              disabled={!canSelectAll}
                              id="th_comman_checkbox"
                              onChange={(e) =>
                                handleSelectAll(e.target.checked)
                              }
                              className="inventorytableHead_main"
                              data-select="inventorytableHead_main"
                              type="checkbox"
                            />
                            <label
                              htmlFor="th_comman_checkbox"
                              className="com-check-label"
                            />
                          </div>
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[1] = el)}
                          className="fixed-side"
                          style={{
                            position: "sticky",
                            left: stickyLefts[1],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          #
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[2] = el)}
                          className="fixed-side"
                          style={{
                            position: "sticky",
                            left: stickyLefts[2],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("Img")}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[3] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[3],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("SKU")}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[4] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[4],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("Item")}
                          {renderColFilterDropdown("item", colDropdownRefItem)}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[5] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[5],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("Collection")}
                          {renderColFilterDropdown(
                            "collection",
                            colDropdownRefCollection,
                          )}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[6] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[6],
                            zIndex: 3,
                            background: "#fff",
                            boxShadow: "3px 0 5px -2px rgba(0,0,0,0.15)",
                          }}
                        >
                          {t("Metal")}
                          {renderColFilterDropdown(
                            "metal",
                            colDropdownRefMetal,
                          )}
                        </th>
                        <th>
                          {t("Stone")}
                          {renderColFilterDropdown(
                            "stone",
                            colDropdownRefStone,
                          )}
                        </th>
                        <th>
                          {t("Size")}
                          {renderColFilterDropdown("size", colDropdownRefSize)}
                        </th>
                        <th>
                          {t("Stock ID")}
                          {renderColFilterDropdown(
                            "stock_id",
                            colDropdownRefStockId,
                          )}
                        </th>
                        <th></th>
                        <th></th>
                        <th>{t("Qty")}</th>
                        <th>{t("Price")}</th>
                        <th>{t("Aging")}</th>
                        <th>
                          {t("Location")}
                          {renderColFilterDropdown(
                            "location",
                            colDropdownRefLocation,
                          )}
                        </th>
                        <th className="text-center">
                          {t("Status")}
                          {renderColFilterDropdown(
                            "status",
                            colDropdownRefStatus,
                          )}
                        </th>
                        <th className="text-center">{t("POS Order")}</th>
                        <th className="text-center">{t("Customer")}</th>
                        <th className="text-center">{t("Delivery Date")}</th>
                        <th className="text-center">{t("Due Days")}</th>
                        <th>{t("Remark")}</th>
                      </tr>
                    </thead>
                      </table>
                    </div>
                  </div>
                  <div
                    className="my-inventory-table-hscroll my-inventory-table-hscroll--body"
                    ref={tableBodyScrollRef}
                    onScroll={() => syncInventoryTableScroll("body")}
                  >
                  <table
                    id="my_inventory"
                    ref={tableBodyTableRef}
                    className="stripe row-border order-column common-table table-striped main-table w-100"
                  >
                    <tbody>
                      <>
                        {!datalodaer && inventorylist?.length
                          ? inventorylist.map((result, key) => {
                              return (
                                <tr
                                  key={result?.id || key}
                                  className={
                                    result?.rowclass ? result.rowclass : ""
                                  }
                                >
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[0],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    <HeldCheckbox
                                      result={result}
                                      disabled={isRowCheckboxLocked(result)}
                                      checked={Selectlist.includes(result?.id)}
                                      wrapperClassName={
                                        isRowCheckboxLocked(result)
                                          ? "com-check checkbox-disabled"
                                          : "com-check"
                                      }
                                      inputClassName="inventorytablecheck inventorytableHead gisClassTh"
                                      onChange={(e) => handleChange(e)}
                                      t={t}
                                    />
                                  </td>
                                  <td
                                    className="fixed-side"
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[1],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    {" "}
                                    {parseInt(key + getSkipNumbers + 1)}
                                  </td>
                                  <td
                                    className="table-pro-img"
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[2],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                    onClick={() =>
                                      setImageid(result?.product_id)
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#ProductViewModal"
                                  >
                                    <img
                                      src={
                                        result?.main_image
                                          ? result?.main_image
                                          : base_assets +
                                            "images/icon/camera_profile.png"
                                      }
                                      alt=""
                                    />
                                  </td>
                                  <td
                                    className="col-highlight link-color cursor-pointer"
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[3],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                    onClick={() => {
                                      setOneproduct(result);
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ProductInfoModal"
                                  >
                                    {result?.SKU ? result?.SKU : ""}
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[4],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    <div className="tooltip-area-up">
                                      {result?.item_code
                                        ? result?.item_code
                                        : ""}
                                      <span className="tooltip-area-up-text">
                                        {result?.item_name
                                          ? result?.item_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[5],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    <div className="tooltip-area-up">
                                      {result?.collection_code
                                        ? result?.collection_code
                                        : ""}
                                      <span className="tooltip-area-up-text">
                                        {result?.collection_name
                                          ? result?.collection_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[6],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                      boxShadow:
                                        "3px 0 5px -2px rgba(0,0,0,0.15)",
                                    }}
                                  >
                                    <div className="tooltip-area-up">
                                      {result?.metal_code
                                        ? result?.metal_code
                                        : ""}
                                      <span className="tooltip-area-up-text">
                                        {result?.metal_name
                                          ? result?.metal_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="col-highlight">
                                    {(() => {
                                      const stoneCodes = String(result?.stone_code || "")
                                        .split(",")
                                        .map((s) => s.trim())
                                        .filter(Boolean);
                                      const allStones =
                                        result?.stone_name || stoneCodes.join(", ");
                                      const preview =
                                        stoneCodes.length > 3
                                          ? `${stoneCodes.slice(0, 3).join(", ")}...`
                                          : stoneCodes.join(", ");
                                      if (!preview && !allStones) return null;
                                      return (
                                        <div className="tooltip-area-up">
                                          {preview}
                                          <span className="tooltip-area-up-text">
                                            {allStones}
                                          </span>
                                        </div>
                                      );
                                    })()}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.size_name ? result?.size_name : ""}
                                  </td>
                                  {result?.status_stock_id === "stock" ? (
                                    <td className="light-blue-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id === "transit" ? (
                                    <td className="status-green-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id ===
                                    "warehouse" ? (
                                    <td className="status-gray-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id === "reserve" ? (
                                    <td className="yellow-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}{" "}
                                          {result?.customer_name ? <br /> : ""}{" "}
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id ===
                                    "repair_order" ? (
                                    <td className="purple-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}
                                          {result?.customer_name ? <br /> : ""}
                                          {result?.POS_Order}
                                          <br />
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id ===
                                    "custom_order" ? (
                                    <td className="danger-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}
                                          {result?.customer_name ? <br /> : ""}
                                          {result?.POS_Order}
                                          <br />
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                  <td className="col-highlight">
                                    {traceabilityEnabled && result?.traceability_on ? (
                                      <img
                                        src={traceimg}
                                        alt="trace_on"
                                        data-bs-toggle="modal"
                                        data-bs-target="#TraceabilityModal"
                                        onClick={() => handleTraceData(key)}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td
                                    className="sku-col table_btn_expand_col col-highlight"
                                    onClick={() => {
                                      setProduct_id(result?.id);
                                      setCart_id(result?.pos?.cart_id);
                                    }}
                                  >
                                    {result?.allocatable === true ? (
                                      <div className="td-icons-wrap m-3 d-inline-block">
                                        <div className="td-icons-wrap-link">
                                          <img
                                            className="img"
                                            src={
                                              base_assets +
                                              "images/icons/link-icon.svg"
                                            }
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <div className="td-icons-wrap-user d-inline-block">
                                      {result?.pos_Qty !== 0 &&
                                      result?.pos?.order_type ===
                                        "repair_order" ? (
                                        <div className="tooltip-area-up">
                                          <div className="td-icons-wrap-user d-inline-block">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-purple.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                          <span className="tooltip-area-up-text">
                                            {result?.customer_name}
                                            {result?.customer_name ? (
                                              <br />
                                            ) : (
                                              ""
                                            )}
                                            {result?.POS_Order}
                                            <br />
                                            {result?.delivery_date}
                                          </span>
                                        </div>
                                      ) : result?.pos_Qty !== 0 ? (
                                        <div
                                          className="tooltip-area-up"
                                          data-bs-toggle="modal"
                                          data-bs-target="#allocation-listedModal"
                                        >
                                          <div className="td-icons-wrap-user d-inline-block">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-red.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                          <span className="tooltip-area-up-text">
                                            {result?.customer_name}
                                            {result?.customer_name ? (
                                              <br />
                                            ) : (
                                              ""
                                            )}
                                            {result?.POS_Order}
                                            <br />
                                            {result?.delivery_date}
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="td-icons-wrap-user d-inline-block">
                                      <div className="tooltip-area-up">
                                        {result?.status_type === "  " ? (
                                          <div className="td-icons-wrap-user d-inline-block">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-yellow.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}
                                          {result?.customer_name ? <br /> : ""}
                                          <br />
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="col-highlight">
                                    {result?.po_QTY ? result?.po_QTY : 0}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.price ? result?.price : ""}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.aging ? result?.aging : "0"}
                                  </td>
                                  <td className="location-td col-highlight">
                                    {" "}
                                    <span className="link-color">
                                      {" "}
                                      {result?.location_name
                                        ? result?.location_name
                                        : ""}{" "}
                                    </span>{" "}
                                    <span className="text-center location-td-sub">
                                      {result?.warehouse_location_name
                                        ? result?.warehouse_location_name
                                        : ""}
                                    </span>{" "}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.status_type === "stock" ? (
                                      <div className="status-dot light-blue-bg  tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Stock")}
                                        </span>
                                      </div>
                                    ) : result?.status_type === "transit" ? (
                                      <div className="status-dot green-bg  tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Transit")}
                                        </span>
                                      </div>
                                    ) : result?.status_type === "warehouse" ? (
                                      <div className="status-dot status-gray-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Warehouse")}
                                        </span>
                                      </div>
                                    ) : result?.status_type === "reserve" ? (
                                      <div className="status-dot yellow-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Reserve")}
                                        </span>
                                      </div>
                                    ) : result?.status_type ===
                                      "repair_order" ? (
                                      <div className="status-dot purple-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Repair Order")}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="status-dot danger-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Custom Order")}
                                        </span>
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.POS_Order ? result?.POS_Order : ""}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.customer_name
                                      ? result?.customer_name
                                      : ""}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.delivery_date
                                      ? result?.delivery_date
                                      : ""}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.due_days ? result?.due_days : ""}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.remark ? result?.remark : "-"}
                                  </td>
                                </tr>
                              );
                            })
                          : ""}
                      </>
                    </tbody>
                    <tfoot>
                      {!datalodaer && (
                        <tr>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>{datatotal?.total_qty ?? 0}</td>
                          <td>
                            {renderStackedTotalPrice(datatotal?.total_price)}
                          </td>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                        </tr>
                      )}
                    </tfoot>
                  </table>
                  </div>
                  </>
                )}
                {datalodaer && <TableLoader />}
              </div>
            </div>
            {inventorylist.length > 0 ? (
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />
        <BarcodeModal selectList={Selectlist} inventoryList={inventorylist} />
        <ProductModal
          data_product={getoneproduct}
          setOneproduct={setOneproduct}
          editproduct_submit={editproduct_submit}
          canEditProductInfo={
            parmissiondatashow?.edit_inv_prod_info?.Edit === 1
          }
        />
        <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
        <Filtermodal
          submitfiltter={(...args) => {
            clearRowSelection();
            Getmyinventory(...args);
          }}
          limit={limit}
          custom_filter_enable={true}
          filterChecked={activeFilters}
          setFilterChecked={setActiveFilters}
          onClearAll={handleClearAllFilters}
        />
        <div
          className="modal fade common-modal common-modal-danger"
          id="allocation-listedModal"
          tabIndex={-1}
          aria-labelledby="allocation-listedModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <img
                  className="common-modal-exclamation-img"
                  src={base_assets + "images/icons/exclamation-mark-red.png"}
                  alt=""
                />
                <p className="modal-content-text">
                  {t("Are you sure you want to Free this item ?")}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn modal-content-no"
                  data-bs-dismiss="modal"
                  onClick={(e) => deallcocation("NO")}
                >
                  {t("Order Close")}
                </button>
                <button
                  type="button"
                  className="btn modal-content-yes"
                  data-bs-dismiss="modal"
                  onClick={(e) => deallcocation("YES")}
                >
                  {t("Deallocate")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TraceabilityModal
        t={t}
        traceData={traceData}
        traceDetail={traceDetail}
      />
      {/* <div
        className="modal fade common-modal"
        id="priceExportStockModal"
        tabIndex={-1}
        aria-labelledby="priceExportStockModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text">
                {t("Do you want to export with Stock ID?")}
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-no"
                data-bs-dismiss="modal"
                onClick={() => downloadexclpricesheet(false)}
              >
                {t("No")}
              </button>
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => downloadexclpricesheet(true)}
              >
                {t("Yes")}
              </button>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="modal fade common-modal"
        id="priceExportStockModal"
        tabIndex={-1}
        aria-labelledby="priceExportStockModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text mb-2">{t("Export format")}</p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="priceExportFormat"
                    value="xlsx"
                    checked={priceExportFormat === "xlsx"}
                    onChange={() => setPriceExportFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="priceExportFormat"
                    value="csv"
                    checked={priceExportFormat === "csv"}
                    onChange={() => setPriceExportFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
              {Selectlist?.length ? (
                <p className="modal-content-text">
                  {t("Do you want to export with Stock ID?")}
                </p>
              ) : null}
            </div>
            <div className="modal-footer">
              {Selectlist?.length ? (
                <>
                  <button
                    type="button"
                    className="btn modal-content-no"
                    data-bs-dismiss="modal"
                    onClick={() => downloadexclpricesheet(false)}
                  >
                    {t("No")}
                  </button>
                  <button
                    type="button"
                    className="btn modal-content-yes"
                    data-bs-dismiss="modal"
                    onClick={() => downloadexclpricesheet(true)}
                  >
                    {t("Yes")}
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="btn modal-content-yes"
                  data-bs-dismiss="modal"
                  onClick={() => downloadexclpricesheet(false)}
                >
                  {t("Export")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade common-modal"
        id="inventoryExportFormatModal"
        tabIndex={-1}
        aria-labelledby="inventoryExportFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text mb-2">{t("Export format")}</p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="inventoryExportFormat"
                    value="xlsx"
                    checked={exportFormat === "xlsx"}
                    onChange={() => setExportFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="inventoryExportFormat"
                    value="csv"
                    checked={exportFormat === "csv"}
                    onChange={() => setExportFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => downloadexclsheet()}
              >
                {t("Export")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModel></ConfirmationModel>
      <ExportOptionModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        onExport={printSelectedProducts}
        loading={productPrintLoading}
      />
    </React.Fragment>
  );
};
export default MyInventory;
